export default {
  common: {
    noFace: 'No face',
    noPermissionTip: 'You do not have permission to use this feature. Please purchase or renew to continue.',
    selected: 'Selected',
    continue: 'Continue',
    open1: 'Open',
    doubleClick: 'Double-click',
    inputKeywordSearch: 'Enter keyword search',
    inputKeywordStartSearch: 'Enter keyword to start search',
    searchHistory: 'Search History',
    clearHistory: 'Clear History',
    notFoundRelatedResults: 'No related results found',
    switch: 'Switch',
    searchProductionLine: 'Production Line',
    selectProductionLine: 'Select production line',
    rotateAngleTip: 'Rotate {angle}',
    plankText: 'Board',
    sendToEzSort: 'send to EzSort',
    downloadEzSort: 'Download EzSort',
    notDownloadTip: 'If EzSort cannot open normally, it may be because you have not downloaded it. Please click the button below to download EzSort',
    updateTip: 'Software update detected. Please restart Guigui!',
    betaTest: 'Free during beta testing',
    ersortSpecail: 'Exclusive for Color Labels',
    exclusiveFeature: 'Exclusive Feature',
    elementCanBeDragTip: 'Element can be dragged',
    checkPlankIsConflict: 'Checking plank status',
    preferenceSaveErr: 'Error saving preferences',
    guimen: 'Cabinet door',
    preferenceLoadTip: 'Loading your preferences...',
    preferenceLoadErrTip: 'Failed to load preferences. Please refresh and try again to avoid incorrect preference settings!',
    localFileIsBeingWrite: 'Local file is being written',
    unnamedFile: 'Unnamed file',
    taskMonitor: 'Task Monitoring',
    downloadByType: 'Download {type}',
    slotKnifeErr: 'The slot-specific processing tool is missing. Please check the production line settings! 【{msg}】',
    anewChooseCatalog: 'Re-select directory',
    downloadSetting: 'Download settings',
    attention: 'Attention',
    unit: 'Pieces',
    defaultUse: 'Default Use',
    defaultChooseUse: 'Default selection',
    requestFail: 'Request failed',
    downloadDoneByType: '{type} download completed',
    sysTip: 'System Tip',
    pleaseChoose: 'Please select',
    confirmDelete: 'Confirm deletion',
    notDataTipByType: 'No data available, please {msg} first',
    paginationTotalTip: 'Items {current}-{page} of {total} total',
    chooseAmountData: 'Selected {number} items of data',
    moreOperate: 'More',
    transferByType: 'Transfer {type}',
    clickCopy: 'Click to copy {type}',
    currentLine: 'Current Line',
    remark: 'Remarks',
    customFunction: 'Custom Function',
    limitedTimeTrial: 'LTF',
    startDate: 'Start Date',
    endDate: 'End Date',
    startTime: 'Start time',
    endTime: 'End time',
    lastMonth: 'Last Month',
    lastSixMonth: 'Last half year',
    lastYear: 'Last Year',
    searchByType: 'Please enter {type} to search',
    addTime: 'Add Time',
    startArrange: 'Start Nesting',
    select: 'Select',
    search: 'Search',
    name: 'Name',
    plankNo: 'Panel No.',
    plankName: 'Part Name',
    orderNo: 'Order number',
    order: 'Order',
    partNameWithoutRoomCabinet: 'Board name (without room/cabinet)',
    plankRemark: 'Part Remark',
    room: 'Room',
    orderAddress: 'Project Address',
    matCode: 'Material code',
    matCode2: 'Material',
    plankMatCode: 'Board material',
    count: 'Count',
    customer: 'Customer',
    customerInfo: 'Customer information',
    factoryOrderNo: 'Factory order number',
    roomName: 'Room',
    color: 'Color',
    plankColor: 'Board color',
    plankThick: 'Board thickness',
    plankHighGloss: 'Highlight Properties',
    thick: 'Thickness',
    front: 'Front',
    back: 'Back',
    slot: 'Slot',
    hole: 'Hole',
    hsInfo: '{hole} Hole {slot} Slot',
    diameter: 'Diameter',
    finishedWidth: 'Finished product width',
    finishedHeight: 'Finished product length',
    finishedArea: 'Finished product area (㎡)',
    remarks: 'Remarks',
    remark1: 'Remark 1',
    remark2: 'Remark 2',
    remark3: 'Remark 3',
    remark4: 'Remark 4',
    remark5: 'Remark 5',
    remark6: 'Remark 6',
    remark7: 'Remark 7',
    remark8: 'Remark 8',
    remark9: 'Remark 9',
    remark10: 'Remark 10',
    remark11: 'Remark 11',
    remark12: 'Remark 12',
    remark13: 'Remark 13',
    remark14: 'Remark 14',
    remark15: 'Remark 15',
    remark16: 'Remark 16',
    texture: 'Texture',
    normal: 'Vertical texture',
    reverse: 'Horizontal texture',
    notCare: 'No texture',
    holeSlotsStastic: 'Hole and Slot Count',
    edge: {
      title: 'Edge',
      info: 'Edge information',
      front: 'Front edge',
      back: 'Back edge',
      left: 'Left edge',
      right: 'Right edge',
      up: 'Upper edge',
      down: 'Bottom edge'
      },
    isSpecial: 'Special-shaped',
    notSpecial: 'Not Special',
    textOfDoorPlank: 'Door board',
    textOfNotDoorPlank: 'Not a Door Board',
    isDoorPlank: 'Door board',
    notDoorPlank: 'Not a Door Board',
    width: 'Width',
    long: 'Length',
    plankWidth: 'Board width',
    plankHeight: 'Board length',
    shortLong: 'Short Side Length',
    shortWidth: 'Short Side Width',
    plankShape: 'Plank Shape',
    detail: 'Details',
    cancel: 'Cancel',
    confirm: 'Confirm',
    alreadyKnow: 'I already know',
    Noprompts: 'No more prompts',
    deep: 'Depth',
    other: 'Others',
    heighGloss: 'High gloss',
    heighGlossPlank: 'High-gloss board',
    heighGlossSide: 'High gloss side',
    notHeighGloss: 'Not High Gloss',
    notHeighGlossPlank: 'Not a High Gloss Board',
    saveSuccess: 'Save success',
    deleteSuccess: 'Delete success',
    addSuccess: 'Add success',
    editSuccess: 'Edit success',
    engraving: 'Engraving machine',
    electronicSaw: 'Electronic Saw',
    glassEquip: 'Glass Cutting Machine',
    labelingMachine: 'labeling machine',
    copy: 'Copy',
    paste: 'Paste',
    undo: 'Cancel',
    move: 'Move',
    PTP: 'PTP',
    dock56FDrill: '5/6-Face Drilling Machine',
    sideHoleDrill: 'Side hole drilling machine',
    combination: 'Combination Machine',
    integration: 'Integration Machine',
    standardPlank: 'Standard Board',
    standardMaterial: 'Standard Material',
    standardMaterialTip: 'Attention: After completing the adjustment of the large board information, users who use cabinet layout production need to restart the cabinet client to apply the latest changes!',
    specialMaterial: 'Special Material',
    specialPlank: 'Special Board',
    singlePlank: 'Single-Sided Board',
    previous: 'Prev',
    plankInfo: 'Large board details',
    moreResult: 'More layout solutions',
    moreResultTip: 'There are slots for edge processing on the large board, and the large board will not participate in the re-layout.',
    ok: 'Confirm',
    dispersePaibanTip: 'Some large boards cannot be distributed for layout, you can manually adjust or switch the layout plan to avoid running the board!',
    next: 'Next',
    rate: 'Utilization',
    paibanBatch: 'Layout batch',
    return: 'Return',
    FGNo: 'Contract Number',
    refresh: 'Refresh',
    inde: 'Serial number',
    productionLine: 'Line',
    operation: 'Operation',
    colorPlaceHolder: 'Press enter to create a color swatch',
    saveAndContinue: 'Save and Continue',
    reset: 'Reset',
    check: 'Query',
    inputPlaceholder: 'Please enter',
    filter: 'Filter',
    all: 'All',
    exportPDF: 'Export pdf',
    exportPic: 'Export image',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    restore: 'Restore',
    save: 'Save',
    saveSetting: 'Save settings',
    isHeightGloss: 'Please select if it is a high-gloss board',
    noSync: 'Not synced',
    sync: 'Synced',
    formatSuccess: '{type} Successful',
    dataLoading: 'Data is loading...',
    warmTip: 'Warm reminder',
    importantTip: 'Important Reminder',
    wellcome: 'Welcome to Cloud Typesetting',
    timeOut: 'Typesetting timed out, do you want to typeset again?',
    notSawKnifeTip: 'Warning: The sawing engraving machine does not have a "Cross-cut Saw Blade" set up, which prevents nesting. Please proceed to add it!',
    doorFrameKnifeRadiusErr: 'You have enabled the "Saw Cutting Engraving Machine - Door Frame Cutting" feature. The cutting tool radius is greater than the saw blade thickness, so nesting cannot be performed!',
    doorFrameIrregularPlankErr: 'You have enabled the "Saw Cutting Engraving Machine - Door Frame Cutting" feature. This feature does not currently support irregular panel nesting!',
    warning: 'Warning',
    export: 'Export',
    mark: 'Mark',
    noMark: 'Unmarked',
    sawArrange: 'Saw Cut',
    directArrange: 'Straight Cut',
    area: 'Area',
    plankNum: 'Part Barcode',
    loc: 'Cabinets',
    cutHeight: 'Cutting length',
    cutWidth: 'Cutting width',
    defaultProduction: 'Default Line',
    surplusNum: 'Surplus Barcode',
    tip: 'Tip',
    history: 'History',
    hinge: 'Hinge hole',
    hingeScrew: 'Hinged door panel pilot holes',
    CCPXHole: 'Three-in-one eccentric hole',
    stretchHinge: 'Straightener slot and hinge cup hole',
    stretch: 'Straightener',
    stretcher: 'Straightener Slot',
    eccHole: 'Eccentric hole',
    preHole: 'Pre-embedded Hole',
    clothole: 'Clothes rod hole',
    backPlank: 'Backboard Slot',
    ALS: 'Hidden Pull Slot',
    doorSlot: 'Door Metal Slot',
    drawerSlot: 'Drawer Metal Slot',
    lkSlot: 'Lock slot',
    KC: 'Trousers drawer hole',
    stealth: 'Invisible component',
    lightSlot: 'Light slot',
    ConventionalHole: 'Conventional hole',
    Keyhole: 'Keyhole',
    allHole: 'All Holes on the Specialty Board',
    allSlot: 'All Slots on the Specialty Board',
    freedomAllHoleSlot: 'Freedom All Holes and Slots on the Specialty Board',
    freedomAllHoleSlotTip: 'Freedom Board: A board with a non-right angle corner',
    millInfo: 'Horn handle',
    haiTang: 'Begonia corner',
    FSDrill: 'Five/Six-Face Drilling Machine',
    engraving2: 'Engraving Machine',
    xyReverse: 'XY Axis Swap',
    autoXYReverse: 'Hole slot processing equipment automatic adaptation exchange',
    autoXYReverseTip: 'After enabling, the processing data of five/six-face drill and side hole drilling machine will be automatically adapted to the XY axis swap of the engraving machine',
    autoXYReverseTip2: 'Note: PTP is not supported',
    xyReverseTip: 'The XY axis interchange function is currently not compatible with the correct placement of L-shaped residual material gaps. Please use it with caution',
    rect: 'Rectangle',
    Ltype: 'L-shaped',
    archive: 'Archive',
    tellPlaceholder: 'Please enter your phone number',
    knivesStore: 'Knife Storage',
    roll: 'Flip Part',
    pause: 'Pause',
    editTrans: 'Edit Translation',
    translateManager: 'Translation Manager',
    grating: 'Gratings',
    addressEditErr: 'Modification of project addresses is not supported for multiple orders',
    customerEditErr: 'Modification of customer information is not supported for multiple orders',
    factoryEditErr: 'Modification of factory order numbers is not supported for multiple orders',
    roomNameEditErr: 'Modification of room names is not supported for multiple orders',
    remarkEditErr: 'Modification of order remarks is not supported for multiple orders',
    toMaterialList: 'Go to Material List',
    deleteFail: 'Deletion failed, please try again later!',
    batchRestore: 'Batch restore',
    batchDelete: 'Batch delete',
    workShop: 'Workshop Production',
    FGAdrress: 'Order address/Contract number',
    cuttingSize: 'Cutting size',
    finishedSize: 'Finished size',
    labelImg: 'Label Image',
    layoutImg: 'Typesetting diagram',
    file: 'File',
    folder: 'Folder',
    reName: 'Rename',
    to: 'To',
    plankUnit: 'Sheet',
    tagTemp: 'Label Template',
    roomRemark: 'Room Remark',
    noModificationPermission: 'No modification permission',
    modificationRecord: 'Modification record',
    page: 'Page',
    strip: 'Strip',
    jump: 'jump',
    freeAgreement: 'Software disclaimer agreement',
    preStep: 'Pre step',
    nextStep: 'Next step',
    upload: 'Upload',
    uploading: 'Uploading',
    iAgree: 'I agree',
    pleaseSelectPlank: 'Please select at least one board',
    saveToStoreTip: 'Please select at least one non-cut-out piece',
    fileIsNotExist: 'file does not exist',
    selectAll: 'Select all',
    pdfTag: 'PDF Tag',
    tagImage: 'Tag Image',
    guigui: 'Guigui',
    gratingSlot: 'Grating Slot',
    deleteTip: 'After deleting this data, it cannot be recovered. Are you sure you want to delete this data?',
    deleteError: 'An unknown error occurred and the deletion failed',
    cancelDelete: 'Deletion canceled',
    confirmDeleteTip: 'After deleting, the board will be entered in the lower right corner of the page in the "Board to be typeset - not stored", whether to confirm the deletion of the data?',
    confirmDeleteBujianTip: 'After deleting, the part will be entered in the lower right corner of the page in the "Parts Library", whether to confirm the deletion of the data?',
    confirmSureDeleteTip: 'It has been detected that there are small boards with the same material in the current layout library. Are you sure you want to continue deleting this large board?',
    deleteEmptyTip: 'Whether to delete this large board',
    notCanDelete: 'The cropped remaining materials do not support warehousing',
    new: 'New',
    innerBluneFailure: 'Inline cloud typesetting does not take effect',
    deleteBigPlankTip: 'A large slab must be kept under the current material color thickness and cannot be deleted!',
    continueExport: 'Ignore and proceed to the output file',
    toCheck: 'Go check',
    pleaseCheck: 'Please check: The current layout result has hole-slot conflict/flying out small plate/depth anomaly. Please check!',
    clampHandCheck: 'Detected some of your plate hole slot can not avoid the clamp position, please adjust manually',
    conflictPartDetail: 'Details of conflicting plates',
    colorNotUndefined: 'The color can not be empty',
    materialNotUndefined: 'The material can not be empty',
    newSetting: 'New feature',
    downImageErrTip: 'Exporting images failed because the enabled labeling feature divides images into different folders based on the large board. You need to select the small board labels to export together.',
    downNcErrTip: 'Downloading NC failed because the enabled labeling feature divides images into different folders based on the large board. You need to select the small board labels to export together.',
    downNcErrTipForSurFolder: 'Downloading NC failed because the enabled labeling feature divides images into different folders based on the large board. You need to select the small board labels to export together.',
    yes: 'Yes',
    no: 'No',
    checkColorPrint: 'At present, the color label has been turned on, please use the color printer to print~',
    colorRules: 'After turning on the generation of color labels, orders/rooms/cabinets/door panels will be distinguished by color, and the maximum number of color labels supported for the same type of data is 12, the specific rules are as follows:',
    greyPart: 'The gray part of the label on the right is',
    region: 'Area',
    notSame: 'The color of the {regionName} region is different',
    doorTip: 'Grey is the door panel, white is the non-door panel',
    exist: 'Existence',
    limitNotEffect: 'If there are more than 12 data, the color label will not take effect',
    hoverTip: 'Images with the bmp suffix are encoded in black and white, and cannot be output with color labels',
    lock: 'Lock',
    unlock: 'Unlock',
    batchLock: 'Batch Lock/Unlock',
    surplusLock: 'Surplus Material Lock',
    surplusUnlock: 'Surplus Material Unlock',
    is: 'Yes',
    not: 'No',
    savingHistory: 'Saving history file',
    saveHistorySuccess: 'Save history file successfully',
    saveHistoryFail: 'Failed to save the history file',
    bw: 'Whether to export black and white labels',
    modular: 'Unit cabinets',
    autoAdjust: 'Auto-adjust',
    cutOrderTip: 'An error has been detected in your 【{errorCutOrdersString} slab】 cutting order! Please make adjustments before downloading the NC file',
    lockedCutOrderTip: '【The {errorCutOrdersString} board】is locked, please go to manually modify it',
    paibanImgCutOrderTip1: 'Detected your',
    paibanImgCutOrderTip: 'there is an error in the cutting sequence! Please go to the layout page to adjust before exporting the layout file',
    goAdjust: 'Go adjust it',
    autoAdjustWarning: 'The current typesetting result does not support automatic adjustment',
    checkNetwork: 'Please check your network',
    moreInfo: 'See more information',
    continueLayout: 'Continue layout',
    adjustPosition: 'Adjust position',
    specialAndFiveSix: 'When processing irregular shapes with five/six-sided drilling, enabling irregular nesting may cause the board to be cut. Please confirm whether to continue the layout?',
    plankPathErr: 'Internal plank irregularity error, please check if it meets the tool specifications!【{plankIDList}】',
    edgeCheck: 'System detects that the trimming of the large board has been altered; please re-layout to ensure production accuracy',
    iKnow: 'I got it',
    versionErrTip: 'Please update the cabinet to the latest version versionErrTip!',
    annualFeeExpired: 'Your annual subscription has expired, please renew!',
    holeEquipment: 'Drilling Equipment{num}',
    customizedService: 'Support customized services to create your exclusive production plan',
    exampleCombination1: 'Engraving machine + Five/Six-side drill + Side hole machine combination',
    exampleCombination2: 'Electronic saw + Five/Six-side drill + Side hole machine combination',
    exampleCombination3: 'Fully automatic integrated production line + Five/Six-side drill combination',
    feedback: 'You can directly provide your requirements to the Guigui software sales or after-sales service staff',
    markModifiedBoards: 'Mark modified small boards',
    showMoveStep: 'Custom keyboard move step',
    moveStep: 'Keyboard move step',
    existChangeBoards: 'There are changed small boards',
    crossMaterialBoard: 'Cross-material color board',
    skipCrossMaterialTip: "Don't show again for this layout",
    crossMaterialConfirmTip: 'You are currently moving a small board across different materials or colors. {highlight} Continue?',
    crossMaterialConfirmTipHighlight: 'The produced board may have inconsistent material/color with the split order',
    exportHoleSlotPDF: 'Export hole and slot diagram',
    pdfFormat: 'PDF Format',
    dxfFormat: 'DXF Format',
    specialShapeKnivesInfo: 'Cutting Tool Settings',
    specialShapeKnivesInfoTips: 'Small board {stockNum}:',
    specialShapeKnivesInfoTips2: 'The automatic selection of cutting tools has been enabled, the layout data is abnormal, please re-layout from the cutting list, or disable the automatic selection of cutting tools',
    default: 'Default',
    exportLanguage: 'Export language type',
    exportLanguageTip: 'Attention: Some text elements cannot be translated when exported to PDF.',
    highGlossNameTip: 'The high-gloss panels synchronized from the cabinet can be described with other copy without affecting their high-gloss properties.',
    mixPaibanPlanSetting: 'Mix Paiban Plan Setting',
    mixPaibanPlanSettingTip: 'System detected that the mix paiban plan setting has changed, please re-select the current mix paiban plan!',
    mixPaibanPlanSettingOk: 'Set Mix Paiban Plan',
    mixPaibanPlanSettingCancel: 'No, direct layout',
    noMixPaibanPlan: 'No available mix paiban plan',
    mixColors: 'Mix Colors',
    mixPai: 'Mix Paiban',
    plan: 'Plan',
    mixPaibanTitle: 'Different Color Small Boards to be Placed Together',
    mixColorsTip: 'It is possible to define which color parts can be produced as the same color on a large board, while not changing the original color information of the parts.',
    mixColorsTip2: 'After adding a plan, it needs to be enabled in the cutting list to take effect',
    mixColorsTip3: 'The different color edge function exists in conflict and cannot be enabled at the same time',
    mixErrTip: 'Mix paiban plan missing required fields, please check',
    addPlan: 'Add Plan',
    chooseMatcode: 'Choose Material',
    chooseColor: 'Choose Color',
    defineColor: 'Define as',
    confirmDeletePlan: 'Confirm to Delete the Plan',
    trimmingMethod: 'Trimming method',
    followStandardTrim: 'Follow the trimming value of the standard board in the original panel',
    trimToast: 'Attention: You are using the custom trimming feature for leftover materials, only saw cutting layout can be selected',
    individualTrimValue: 'Set trimming value individually',
    topTrimEmptyToast: 'Top trimming value cannot be empty',
    bottomTrimEmptyToast: 'Bottom trimming value cannot be empty',
    leftTrimEmptyToast: 'Left trimming value cannot be empty',
    rightTrimEmptyToast: 'Right trimming value cannot be empty',
    topTrimBlurToast: 'Please enter the top trimming value',
    bottomTrimBlurToast: 'Please enter the bottom trimming value',
    leftTrimBlurToast: 'Please enter the left trimming value',
    rightTrimBlurToast: 'Please enter the right trimming value',
    effectToast: 'The custom trimming feature only takes effect for welded boards',
    defaultTrimSetting: 'Default leftover trimming setting',
    enterHere: 'Enter here',
    permissionTipExportDxf: 'Export DXF Hole Slot Diagram',
    permissionTipSurplusRecycleBin: 'Surplus Recycle Bin',
    permissionTipAdvancedNesting: 'Advanced Irregular Nesting',
    permissionTipPanelGrainAlign: 'Panel Grain Align',
    permissionSeparator: ', ',
    missingPermissionTip: 'Missing permissions: {permissions}'
    },
  home: {
    head: {
      production: 'Product Introduction',
      resolve: 'Solutions',
      about: 'About Us',
      equipment: 'Equipment',
      tell: 'Complaint Hotline',
      enter: 'Enter Cloud Typesetting'
      },
    swiper: {
      case1: {
        tag: 'Newly Upgraded Version',
        subTitle: 'The Intelligent Brain of Machines',
        description: 'A cloud-based online typesetting optimization software revolutionizing the industry'
        },
      case2: {
        title: 'Cabinet Production',
        subTitle: 'Technological Innovation',
        description: 'Supports integration with various labeling machines, cutting machines, side-hole machines, five-sided PTP, and five/six-sided drilling machines'
        },
      case3: {
        title: 'Industrial Brain',
        subTitle: 'Solutions',
        description: 'Intelligent typesetting algorithm achieves higher material utilization rates'
        }
      },
    statistics: {
      today: "Today's Scheduling",
      toMounth: 'Monthly layout volume',
      outturn: 'Yield Rate',
      cumulative: 'Cumulative Users'
      },
    intro: {
      title: 'Enterprise-grade Big Data Cloud-based Online Typesetting Software',
      subTitle: 'Insights into industry trends, focusing on customer needs, enabling digital transformation and upgrading of enterprises, driving the automation of the internet furniture production industry. Introducing AI-assisted algorithms for the existing panel furniture industry production scenarios, continuously contributing to new growth for enterprises.',
      menue: {
        case1: {
          title: 'Online typesetting',
          subTitle: 'Typesetting at any time',
          description: 'No need to download software, typesetting can be done at any time, remote control without relying on a computer.'
          },
        case2: {
          title: 'Multi-line Production',
          subTitle: 'Quick switching between production lines',
          description: 'Supports rapid processing on multiple production lines simultaneously, with quick switching between production lines.'
          },
        case3: {
          title: 'Precise Production',
          subTitle: 'Precise typesetting and parameter settings',
          description: 'Precise typesetting and precise parameter settings, making panel production more accurate.'
          },
        case4: {
          title: 'Custom Production',
          subTitle: 'Custom labels, five/six-sided drilling, scrap shapes',
          description: 'Custom labels, custom five/six-sided drilling, custom scrap shapes, combined equipment processing.'
          }
        }
      },
    fangan: {
      title: 'Industry Professional Solutions',
      subTitle: 'Low cost, high output value, intelligent algorithms increase panel utilization, compatible with various design software, providing users with the optimal production plan.',
      menue: {
        case1: {
          title: 'Integrated Online Order Reception and Production',
          description: 'Remote online operation, overcoming spatial obstacles, orders can be synchronized to the factory at any time, design and production completed synchronously.'
          },
        case2: {
          title: 'One-click Switching between Production Lines',
          description: 'Customizable production lines, supporting multiple production lines and multiple types of equipment docking.'
          },
        case3: {
          title: 'Intelligent Algorithm Improves Panel Utilization',
          description: 'Traditional algorithms have low panel utilization, intelligent algorithms provide precise parameter settings, customized production plans.'
          },
        case4: {
          title: 'Professional Cutting Solutions',
          description: 'Optimize cutting sequence and cutting points, making the path shorter and cutting more stable.'
          }
        }
      },
    aboutUs: {
      title1: 'Xingeer Human Settlements Technology',
      subTitle: 'Leader in the Transformation of the Furniture Manufacturing Industry',
      description: 'Xingeer Enterprise, focused on realizing the internet transformation of the traditional furniture manufacturing industry.',
      culture: {
        case1: {
          title: 'Enterprise Purpose',
          subTitle: 'Help factories achieve triple growth'
          },
        case2: {
          title: 'Cultural Values',
          subTitle: 'Customer-centered, based on the efforts of employees, hard work, benefiting the people'
          },
        case3: {
          title: 'Guiding Ideology',
          subTitle: 'Mass line, building an elite team with sales force, product force, and organizational force'
          }
        },
      feature: {
        case1: 'Professional Team Maintenance',
        case2: 'Continuous Updates and Iterations',
        case3: 'One-on-one After-sales Service',
        case4: 'Customized Functionality Service'
        }
      },
    cooperation: {
      title: 'Sincere Cooperation, Creating a Shared Future',
      subTitle: 'The docking equipment brands cover 90% of the commonly used domestic industrial equipment, with 107,554 merchants joining us.'
      },
    footer: {
      contact: {
        title: 'Contact us',
        adrres: 'Address: No. 50 Xiuxi, Binhu District, Wuxi City, Jiangsu Province',
        subAdrres: 'K-park Service Center, Building 1, 16th Floor',
        tell: 'Telephone'
        },
      business: {
        title: "Xin Ge Er's Core Business",
        department1: 'Door and Window Software Department',
        department2: 'Furniture Software Department',
        department3: 'Prefabricated Construction Department',
        department4: "Xin Ge Er's Official Website"
        },
      brand: {
        title: "Xin Ge Er's Affiliate Brands",
        brand1: 'Cai Shen Jin Fu',
        brand2: 'Mentu.com',
        brand3: 'Ding Xin Investment',
        brand4: 'San Zhang Tu Technology',
        brand5: 'Shanghai Fen Mo Technology'
        },
      organization: {
        title: "Xin Ge Er's Global Branches",
        organization1: 'Xin Ge Er - South China Bureau (Foshan Branch)',
        organization2: 'Xin Ge Er - North Bureau (Linyi Branch)',
        organization3: 'Xin Ge Er - Southwest Bureau (Chengdu Branch)',
        organization4: 'Xin Ge Er - GG Western Service Center',
        organization5: 'Xin Ge Er - GG Eastern Service Center',
        organization6: 'Xin Ge Er - Agent Cluster',
        organization7: 'Xin Ge Er - International Market Department'
        },
      follow: {
        title: 'Scan to Follow GG'
        },
      friendLink: {
        link1: 'Xin Ge Er Software',
        link2: 'K Show Purchasing Software',
        link3: 'Mentu.com',
        link4: 'All Aluminum Cabinet Software',
        link5: 'ZOL Software Download',
        link6: 'Hua Jun Software Park',
        link7: 'Download.com',
        link8: 'ZOL Software Download',
        link9: 'Green Resource Network',
        link10: 'Wardrobe Franchise',
        link11: 'Home Franchise',
        link12: 'American Standard Bathroom Franchise'
        }
      }
    },
  login: {
    title: 'Login',
    tell: 'Phone number',
    password: 'Password',
    passwordPlaceholder: 'Please enter the password',
    forget: 'Forgot password?',
    registerAccount: 'Register account',
    backLog: 'Go Back to Login',
    verifyCode: 'Verification code',
    getVerifyCode: 'Get verification code',
    verifyCodeErr: 'Verification code error',
    confimPassword: 'Confirm password',
    confimPasswordPlaceholder: 'Please confirm your password',
    editPassword: 'Change password',
    register: 'Register',
    reSend: 'Get a new code',
    loginLoadText: 'Logging in, please wait...',
    loadingPageTextL: 'Login successful, loading page structure...',
    loginSuccess: 'Login successfully',
    tellErr: 'Invalid phone number format',
    passwordErr: 'Please enter the password'
    },
  main: {
    head: {
      title: 'Bluen',
      subTitle: 'Save time, materials, and effort',
      task: 'New Task',
      arrange: 'Nest',
      surplus: 'Offcuts',
      setting: 'Settings',
      find: 'Discover',
      upgrade: 'Upgrade now',
      editNickName: 'Edit nickname',
      editPassword: 'Change password',
      logout: 'Log out',
      notice: 'Announcement',
      enterOfficial: 'Visit the Official Website',
      equipment: 'Equipment',
      help: 'Help',
      importFunc: 'View exclusive features',
      enterThinkerOfficial: 'Enter the Xin Ge Er Official Website',
      history: 'Save history',
      plankManager: 'Raw Panel',
      tagManager: 'Label Mgmt',
      suplumentManager: 'Replacement & Nest Pool',
      fileManager: 'File Mgmt',
      productionLine: 'Device Link',
      workeShop: 'Cloud Production',
      useLesson: 'Usage Tutorial',
      videoLesson: 'Video tutorial',
      prolineManager: 'Line Mgmt',
      materialManager: 'Panel Mgmt',
      productManual: 'Product Manual',
      medialRelated: 'Gradient-related'
      },
    sideBar: {
      title: 'Production Optimize',
      materialList: 'Cut List',
      paibanTask: 'Nest Tasks',
      paibanResult: 'Nest Scheme',
      printTag: 'Print Labels',
      history: 'Save History',
      limitDate: 'LTF',
      surplusManager: 'Surplus Stock',
      translateManager: 'Translate Management',
      moreSettings: 'More settings',
      deepSeekTitle: 'Consulting consultant',
      paibanCommune: 'Nest Group'
      },
    allRead: 'All Read',
    learnMore: 'Learn More',
    noticeEmpty: 'No Announcements Available...',
    noticeErr: 'Error Fetching Detailed Announcements',
    feedBack: {
      tab1: 'Submit feedback',
      tab2: 'Feedback record',
      type: 'Feedback type',
      typePlaceholder: 'Please select a feature',
      description: 'Description',
      descriptionPlaceholder: 'Hi! Please provide a detailed usage scenario description of at least 15 words to help us better assist you. Thank you for your cooperation!',
      uploadPic: 'Add Pictures (Max 6 images, each no larger than 10MB)',
      tell: 'Contact number',
      submit: 'Submit',
      admin: 'Cloud Typesetting Administrator:',
      picTip: 'Image: (Click to expand and view image details)',
      empty: 'No Feedback Data Available',
      picErr: 'Each image should not exceed 10MB',
      contentErr: 'The number of characters should be between 15 and 300',
      necessary: 'This field is required'
      }
    },
  taskPage: {
    tab1: 'Production Task',
    tab2: 'Mass production queue',
    filter: {
      title: 'Filter',
      unArrange: 'Not formatted',
      arranged: 'Arranged',
      allArranged: 'All Arranged',
      preLayout: 'Pre-layout'
      },
    search: {
      placeholder: 'Please enter the search content',
      orderName: 'Order name',
      sender: 'Sender'
      },
    importTask: 'Import Task',
    refuseTask: 'Refuse task',
    refreshList: 'Refresh list',
    refuseRecord: 'Refusal Record',
    taskCard: {
      sender: 'imported material list',
      delivery: 'Delivery date',
      delete: 'Delete',
      addToBatch: 'Add to Batch',
      save: 'Save',
      arrange: 'Directly arrange',
      deleteTitle: 'Delete Task',
      checkDetail: 'Click to view details',
      refuse: 'Refuse',
      refuseTime: 'Refusal Time',
      refuseReason: 'Reason for Refusal',
      refuseTask: 'Refuse Task',
      refuseTaskPlaceholder: 'Please enter the reason for refusal',
      addErr: 'Failed to add, please try again later!'
      },
    batchNo: 'batch number',
    batchArrange: 'Batch layout',
    clearBatch: 'Clear the queue',
    taskCount: 'Current task count:',
    checkAllTask: 'View all material lists',
    clearSuccess: 'Clearing succeeded',
    record: {
      batchNo: 'batch',
      saveDate: 'Save time',
      materialList: 'Material list',
      arrangedRecord: 'Nest Scheme',
      searchPlaceholder: 'Please enter the batch number',
      tipText: 'Delete this archive or not?'
      },
    errTip: 'No task data available for processing, please go to the task list to add!',
    emptyErr: 'The task order has no plank data, unable to proceed with layout production!',
    operationSuccess: 'Operation successful',
    operationFail: 'Operation failed, please try again later!',
    saveSuccess: 'Save successful',
    plankMaxLimit: 'The number of small planks exceeds the maximum layout limit',
    batchWorning: 'Please produce in batches',
    batchEmptyErr: 'No plank data in the order list, unable to proceed with batch production!',
    noRoomTip: 'No rooms exist, unable to proceed with batch production!',
    refuseHistory: 'Refuse history'
    },
  materialPage: {
    specialProcess: 'Special Process',
    distanceFromTop: 'Distance from top',
    distanceFromRight: 'Distance from right',
    hingeData: 'Hinge Data',
    labelBackProcTip: 'This update has optimized the labeling method on the back of the large board. Now, you can directly seal the edges and punch slots according to the information on the label. Please be informed!',
    openDir: 'Opening direction',
    edgeEmptyTip: 'Trim value cannot be empty',
    edgeNumberLimit: 'Trim value can only be a number',
    chooseSurplusQuantity: 'There are {total} types of available surplus materials, {quantity} types selected',
    noCanSaveInfo: 'No information can be saved',
    chooseBujianStoreQuantity: 'There are {total} supplementary pieces, {quantity} supplementary planks can be included, {chooseQuantity} planks selected',
    isConfirmPushToAwaitStore: 'Are you sure you want to add the selected planks to the awaiting layout warehouse?',
    enterAutoCreateMatCode: 'Press Enter to auto-create material',
    chooseAwaitStoreQuantity: 'There are {total} small planks in the awaiting layout warehouse, {quantity} planks can be included in the layout, {chooseQuantity} planks selected',
    defaultFold: 'Parts Data Default Collapsed',
    startArrange: 'Start Nesting',
    importMaterial: 'Import Cut List',
    saveToHistory: 'Save to History',
    addPlank: 'Add board',
    addBujian: 'Add a replacement part',
    deletePlank: 'Delete Part',
    batchEdit: 'Batch Edit',
    moreSetting: 'More settings',
    plankSize: 'Part Size',
    plankSize2: 'Size (Length * Width * Thick)',
    searchPlaceholder: 'Search Panel Name/Panel Number',
    checkArranged: 'View Layout',
    checkErr: 'No arrangement has been made, unable to view!',
    downloadSheet: 'Download  template',
    downloadSheetShowScientific: 'Download  template (showing Scientific notation)',
    exportHoleSlotPDF: 'Export Panel Hole and Slot Diagram',
    style1: 'Style 1',
    style2: 'Style 2',
    style2PDF: 'Style 2 (PDF)',
    style2DXF: 'Style 2 (DXF)',
    style3: 'Style 3',
    importNoCover: 'Import Material List without Overwriting',
    openBujianPlankRecommend: 'Open the patch panel recommended',
    openAwaitStorePlankRecommend: 'Open the library to be formatted small board recommendation',
    openSurplusPlankRecommend: 'Open the remaining material large board recommended',
    pushToAwaitStore: 'Store in the library to be formatted',
    setTableHead: 'Set Material List Header',
    syncConfirm: 'The original data between the cabinet system and the cloud arranging system is inconsistent! Do you want to synchronize with the cabinet system?',
    handleSync: 'Attention: Manual synchronization can be performed in the original sheet management',
    noMoreTip: 'No more prompts',
    checkMore: 'View more',
    noHistory: 'No Saved History...',
    sameOrder: 'There are orders with exported production files, please pay attention to duplicate production issues!',
    markOrder: 'Mark as Produced on the Order Page?',
    editErrTip: 'Multi-order modifications are not supported at this time',
    autoSaveSuccess: 'Autosaved to History!',
    goAdd: 'Go to Add',
    noProductionLine: 'The production line for this record has been deleted. Please rearrange in the Material List',
    fileErr: 'Failed to parse file content. Please confirm the file content!',
    noCheckData: 'No data found!',
    noArrangeTip: 'Cannot view the arrangement plan directly. Please click "Start Arranging"!',
    tooOld: 'The five-six-sided drilling settings are too old',
    contactUs: 'Please contact our after-sales personnel for reconnection',
    pathErr: 'There is abnormal data inside the panel (Panel Number: {errorPathPlankID}). Please check!',
    sizeErr: 'There is abnormal data inside the panel, please check! Panel size：{width}-{height}',
    noKnife: 'The cutting tool diameter has not been set. Please go to the engraving machine to set the tool!',
    noKnifeDiameter: 'The production line cutting knife ({name}) diameter is empty, please go to add the corresponding knife diameter',
    openDifferentMaterialCuttingKnives: 'Different material cutting knives have been enabled',
    sendFactorySuccess: 'Successfully sent to the workshop',
    sendFactoryErr: 'Failed to send to the workshop. Please contact our after-sales personnel for assistance',
    createTaskCard: 'Do you want to create a corresponding task card?',
    surplusStatistics: 'Total available surplus material is',
    surplusStatistics2: 'Selected',
    suplementStatistic: 'supplements, can be accompanied by supplement boards in total ',
    expand: 'Expand',
    packUp: 'Collapse',
    importErr: 'Please select the correct file!',
    sendLoadingText: 'Processing and sending NC files...',
    arrangeLoading: 'A total of',
    arrangeLoading2: 'panels are being optimized for arrangement...',
    dealing: 'Processing...',
    deleteConfirm: 'After deletion, the leftover material will be moved to the Recycle Bin. Are you sure you want to delete this material?',
    copyTip: 'About to copy the selected leftover material',
    copyTip2: 'Please confirm the quantity to be copied',
    surplusHead: {
      shape: 'Shape',
      type: 'Type',
      remark: 'Remarks',
      area: 'Area(m²)',
      area1: 'Area'
      },
    surplusTip: 'There is no available surplus material at the moment. You can go to',
    creatSurplus: 'Create New Surplus',
    orderInfo: 'Order information',
    suplement: {
      statistic: 'There are {total} replacement parts in total, {useable} of which can be used as spare panels, and {selected} have been selected.',
      exportSuplement: 'Export Replacement Parts List',
      suplementLoading: 'Loading Replacement Parts Data',
      exportSuplementIng: 'Exporting Supplement List',
      noMatchSup: 'No matching usable supplemental data found',
      exportTip: 'Please select at least one supplement before exporting'
      },
    empty: 'No panel data available',
    paibanSetting: {
      title: 'Nesting Settings',
      createTask: 'Create Nest Task',
      selectProduction: 'Production Line',
      arrangeWay: 'Nesting Mode',
      suitText: '',
      surplusTrimTip: 'Attention: You have used the custom trimming function for surplus materials, only sawing layout can be selected',
      suitEquipmentNormal: 'For standard engravers',
      suitEquipmentSpecial: 'For glass & saw blade cutters',
      lessRoll: 'Min Flips',
      computedSpecial: 'Calculate Shapes',
      specialTip: 'Slower',
      irregularNesting: 'Irregular Nesting',
      primaryNesting: 'Basic Nest',
      specialShapedPanel: 'Shape + Standard',
      limitedTimeTrial: 'LTF',
      seniorShape: 'Advanced Nest',
      heteromorphicInlay: 'Shape + Shape',
      autoCutSurplus: 'Auto Trim Offcuts',
      cutWay: 'Cutting Method',
      maxRect: 'Cut into Maximum Rectangle',
      fixedRect: 'Cut into Fixed Size',
      minRectSetting: 'Cutting Minimum Size',
      firstCutL: 'Prioritize L-shaped remnant generation',
      firstCutLTip: 'When enabled, it will prioritize cutting rectangular sheets into L-shaped remnants if conditions are met',
      shortLine: 'Short Side Longer than',
      longLine: 'Long Side Longer than',
      setDifferentThickness: 'Set Minimum Cutting Size for Boards of Different Thicknesses',
      defaultRuleTip: 'When the board thickness does not match the rule, cut according to the default rule',
      panelThickness: 'Panel Thickness',
      duplicateMinCutSize: 'The current thickness already has the same minimum cutting size',
      templateEmpty: 'Template data for setting minimum cutting size for boards of different thicknesses cannot be empty!',
      duplicateThicknessData: 'Duplicate thickness data exists in the template for setting minimum cutting size for boards of different thicknesses!',
      atLeastOne: 'At least one item must be retained!',
      maxAddFive: 'You can add up to five!',
      surplusTemplate: 'Common Scrap Templates',
      add: 'Add',
      templateErr: 'When selecting "Cut into Common Size", at least one data template must be selected.',
      cutLong: 'Cutting Length',
      cutWidth: 'Cutting Width',
      baseInfo: 'Basic information',
      continue: 'Confirm and Continue',
      standardSelect: 'Std Panel',
      customPlankOrder: 'Custom Panel Order',
      customPlankOrderDetail: 'UnArranged small board list',
      customPlankOrderTip: 'The embedded cloud layout does not take effect for this feature',
      customPlankOrderBrandTip: 'Orders pending layout contain brand color card boards, this feature is enabled by default',
      surplusPlank: 'Remaining small board list',
      overSizePlank: 'Oversized plate list',
      plankOrder: 'Layout order',
      plankType: 'Board type',
      plankSize: 'Board size',
      plankEdgeOff: 'Trim',
      amount: 'Quantity of cutting materials',
      amountMax: 'Maximum cutting quantity',
      numAndOverSizeTip: 'There are small boards that exceed the size limit and insufficient large boards that cannot be typeset',
      numErrorTip: 'Insufficient usage of large boards to layout',
      overSizeTip: 'There is a small board that exceeds the size limit and cannot be typeset',
      restPartList: 'Unarranged Small Board List',
      layoutOrder: 'Layout Order',
      arrangeAmount: 'Cutting Quantity',
      specialShapeTip: 'Special-shaped surplus materials cannot use sawing layout',
      surplusConflictTip: 'Surplus cutting conflicts with panel outline, please recut',
      stackingMethod: {
        title: 'Stack Align',
        long: 'Long Edge First',
        short: 'Short Edge First'
        },
      seniorShapeTip: '【Advanced Nesting】Free trial period has expired, you can preview the advanced nesting layout result (you can also switch to normal nesting for normal production); if you need to export the advanced nesting production file, please contact the sales staff to purchase~'
      },
    filter: {
      title: 'Panel Filtering',
      search: 'Search',
      all: 'Select all',
      diskSize: 'The space used by the layout history data has been used',
      resetFilter: 'Cancel Filtering'
      },
    edit: {
      title: 'Batch Edit',
      target: 'Modify object',
      onlineSelectRow: 'Only select the row',
      allRow: 'All Rows',
      editKey: 'Contents to be modified',
      editValue: 'Modify to',
      warningTip: 'Attention: the hole groove and irregular shape will be automatically cleared after modification',
      allEdge: 'All Edges'
      },
    add: {
      title: 'Add board',
      continue: 'Confirm and continue',
      matCodeErr: 'The material cannot be empty',
      thickErr: 'Thickness cannot be empty',
      colorErr: 'The color cannot be empty',
      longErr: 'The length of the finished product cannot be empty',
      widthErr: 'Finished product width cannot be empty',
      countErr: 'The quantity must be at least 1'
      },
    delete: {
      tip: 'The data cannot be restored after deletion. Are you sure you want to delete it? ',
      errTip: 'Please select at least one board before performing this operation!',
      errTip1: 'Please select at least one board before performing the layout',
      confirm: 'Confirm deletion'
      },
    restore: {
      confirm: 'Confirm restoration'
      },
    restoreConfirm: 'After restoration, the leftover material will be moved back to the surplus list or surplus stock. Are you sure you want to restore this leftover?',
    restoreBatchConfirm: 'Are you sure you want to restore the selected leftover materials?',
    save: {
      errTip: 'There is no information to save!',
      title: 'Save Scheme',
      subTitle: '(Attention: history is only saved for one year)',
      name: 'Scheme Name',
      historyName: 'Historical scheme',
      successTip: 'Save successfully!',
      fieldTip: 'Save failed!'
      },
    exportErr: 'No board is available for export at the moment',
    exportPicErr: 'An unknown error occurred while exporting the board hole slot diagram. Please contact us for resolution',
    plankNotFound: 'No relevant board found! Please confirm whether to draw the board!',
    noPlankName: 'No board name found',
    plankDataErr: 'The plank data is incorrect. Please check carefully to avoid production losses',
    exportThreeViewErr: 'Failed to export the three views of the hole slot. Please contact after-sales for handling',
    heighGlossWarning: 'Attention: When the material is a high gloss plate, the plate cannot be restored to a high gloss plate after modifying the material!',
    reset: 'Restore default',
    settingHead: {
      title: 'Set the header of the cutting list',
      head: 'Header',
      customHeadName: 'Custom header name',
      example: 'sample',
      tip: ' Operation tips: Drag the header data label left and right to change its position ',
      headerNameEmpty: 'Header name cannot be empty',
      duplicateHeader: 'Duplicate header name'
      },
    copyLine: 'Click to copy the current line below',
    copySuccess: 'Copying {name} data succeeded',
    arranging: 'A total of {count} small boards are being optimized for layout...',
    overSize: {
      title: 'Board oversize',
      subTitle: 'Oversized plate list',
      overSizeTip: 'Plate oversize prompt',
      nonWorkInfo: 'Details of the unprocessable board',
      mergeFrameDoorWholeTip: 'Note: This part is a whole of the merged frame door',
      conflictWorkInfo: 'Details of the conflicting plates',
      warning: 'It is detected that the small board size is too long, resulting in an inability to format! Please adjust the small board size or add corresponding size originals',
      checkInfo: 'View the details of the board',
      tipContent: 'The system has detected that there are oversized plates in the layout template. Below are suggestions for adding special plates. You can manually modify the length and width of the plates and click the One-click Add button below the table to quickly add them and continue with the layout. Alternatively, you can manually add plates in the Original Sheet Settings - Special Plates',
      add: 'One-click add',
      addPlank: 'Add original piece',
      error: 'The board is oversized, and the layout failed',
      successTip: 'Plate added successfully! Re-formatting',
      warningTip: 'Please fill in the length and width of the board!'
      },
    arrangeErr: 'There are anomalies in the internal data of the board, and it is impossible to arrange production',
    nonDelete: 'Cannot Delete',
    addOverSizeTip: 'Oversize exists, please add it again',
    addPlankSuccess: 'Add Special Board successfully',
    addPlankFail: 'Failure to add special board',
    paibanFeedback: 'Layout Feedback',
    cuttingAndPaoban: 'Cutting and Paoban',
    lowUtilizationRate: 'Low Utilization Rate',
    unreasonableLayout: 'Unreasonable Layout',
    feedbackSuccessTip: 'Feedback Success!',
    feedbackFailTip: 'Feedback Failed!',
    mixedLayoutScheme: 'Mixed Nest Plan'
    },
  arrangedPage: {
    subtleDownloadCheckTip: 'The board data has changed but the plan has not been saved. Please click OK to save the plan before proceeding with subsequent operations',
    paibanRequestFailed: 'Layout request failed, please try again',
    accordingPlankCountOrder: 'Sort by large board count from high to low',
    editOrder: 'Edit sequence number',
    dragOrder: 'Drag to sort',
    inputOrder: 'Input sequence',
    editOrderTip: 'Adjust sequence',
    range: 'Range',
    unsupportRotateTip: 'Some boards have been rotated and re-layout is not currently supported. Rotated board numbers:',
    slotErrTip: 'The current panel has edge machining grooves, and re-layout is not supported!',
    lockedPaibanTip: 'The board is locked and cannot be rearranged.',
    batchBujianErrTip: 'The current part does not exist in the original material list data, you can select it from the replenishment/awaiting layout library for re-layout',
    useFolderIsNot: 'It is detected that the file download save location "{type}" does not exist! Please check if the file has been deleted. If using a USB drive, please ensure it is properly connected',
    useFolderIsNot1: 'It is detected that you have not set a file download location, please select a directory first',
    downloadNC: 'Download NC',
    downloadNC1: 'Download NC file',
    reArrange: 'Re-arrange',
    reArrangeSpecifiedMaterialGroup: 'Specified Panel Groups Re-layout',
    specifiedMaterialRelayoutMoreResultTip: 'After specified panel groups are re-laid out, more layout results will no longer be provided',
    searchMaterialGroup: 'Search Panel Groups',
    saveToHistory: 'Save to History',
    moreSetting: 'More',
    cutIndexRe: 'Use shortcut key ctrl+z to undo the previous operation',
    followExportTag: 'Download NC with Label File Export',
    followExportPaibanImg: 'Download the NC file and export the layout drawing file simultaneously',
    followExportWorkerShop: 'Download NC and export purchase order at the same time',
    tagTemplateSelect: 'Label Template Selection',
    showCuttingSequence: 'Show Cutting Sequence',
    showPlankSize: 'Show Sheet Size',
    sendToFactory: {
      title: 'Send to Workshop for Production',
      fileType: 'Label File Type'
      },
    checkData: 'Checking data integrity...',
    dataLoading: 'Loading...',
    addToBujianStore: 'Adding to Spare Parts Warehouse...',
    updateTaskStatus: 'Updating Task Status...',
    sending: 'Sending to workshop...',
    waitLoadding: 'Waiting',
    loadding: 'Loading',
    finish: 'Finished',
    loadSetting: 'Load Settings',
    loadPreference: 'Load Preferences',
    dealTemplate: 'Process Template',
    initTagData: 'Initialize Tag Data',
    prepareDrawData: 'Prepare Label Drawing Data',
    drawDataText: 'Label drawing data',
    genPdfTagFile: 'Generate PDF Tag File',
    genPicTagFile: 'Generate a label image file',
    uploadFile: 'Upload file',
    dealNCFile: 'Process NC File',
    zipFile: 'Generate Local Zip File',
    plankCount: 'Panels',
    rollCount: 'Flips',
    totalRate: 'Nesting Rate',
    rate: 'Optimization Rate',
    useArea: 'Nested Area',
    materialList: 'Material list',
    saveSurplus: 'Save Scrap Material',
    workeShop: 'Purchase Order',
    batchTagging: 'Batch tagging',
    batchTaggingTip: 'Please select the panel below that requires additional labeling',
    holeSlotErr: 'Detected abnormal hole slot depth on the board piece!',
    knivesErr: "The processing tool can't be found when the plate is detected!",
    checkDetail: 'Check details',
    deepErr: {
      title: 'Abnormal Depth of Board Hole Slot',
      errStatistic: '{count} abnormalities found on the sub-board',
      errText: 'Abnormal Part',
      markErrPart: 'Mark the Abnormal Part'
      },
    warningTip: 'For double-sided polished boards: Process the <span class="font-style">glossy side</span> first, then process the <span class="font-style">matte side</span>; For single-sided polished boards: Process the <span class="font-style">matte side</span> directly.',
    showDetail: {
      tip1: 'Click part to view label',
      tip2: ''
      },
    arrangeTip: '(Supports shape nesting)',
    plankOpration: 'Part Ops',
    rotate: 'Rotate 90°',
    notCare: 'No Grain',
    editRemark: 'Edit Remark',
    clearRemark: 'Clear remarks',
    recalcIndex: 'Recalc Cut Points & Order',
    recalcIndexSuccess: 'Recalculation of the drop point and cutting sequence successfully',
    storageArea: {
      title: 'Temporary board piece storage area',
      empty: 'No board pieces stored',
      storageTip: 'Drag board pieces here to temporarily store them'
      },
    subtleArrange: 'Fine layout',
    addPlank: 'Add large sheet',
    deletePlank: 'Delete large sheet',
    deletePlankErr: 'Cannot delete the large sheet as there are smaller sheets on it!',
    useSurplus: {
      title: 'Use scrap material'
      },
    dragWarning: 'Please drag the board piece onto the large sheet!',
    areaWarning: 'Unable to place the board piece. Please check the available space.',
    subtlePage: {
      cut: 'Scrap cutting',
      lineTip: 'If the manual cutting is incorrect, you can use ctrl+z to return to the previous cutting point',
      cancelCut: 'Cancel cutting',
      cutPoint: 'Scrap cutting adsorption point',
      storageArea: 'Temporary storage area',
      cutErr: 'Cutting can only be performed on the large sheet, and cannot touch the smaller sheets!',
      saveErr: 'Please select a scrap material to cut first',
      cutErr2: 'Cutting can only be performed on the main board and cannot exceed the main board!',
      selectTip: 'Please select a surplus material plank for cutting',
      noCutPath: 'Irregular parts cannot cut rectangles',
      cutOperate: 'Remaining material cutting operation',
      line: 'Manual stroke',
      cutErrtip: 'There is a cross problem with the cutting point, please re-cut',
      cutErrtip2: 'The cutting point will exceed the point limit: 9, please re-cut'
      },
    shortCut: 'Shortcut keys',
    updownRoll: 'Scroll up and down',
    leftRightRoll: 'Scroll left and right',
    zoomScale: 'Zoom in and out',
    dragCanvas: 'Drag the page',
    mouseRoll: 'Mouse scroll wheel',
    mouseRight: 'Right mouse button',
    mouseMultiSelect: 'Multi-select board pieces',
    mouseLeft: 'Left mouse button',
    doublePlank: 'Double-click the large sheet',
    keyboard: 'Keyboard',
    picSymble: 'Legend',
    funished: 'Finished product',
    holeSlotConflict1: 'Hole and slot conflict',
    plankErr: 'Board piece conflict',
    frontSlot: 'Front slot',
    backSlot: 'Back slot',
    frontHole: 'Front hole',
    backHole: 'Back hole',
    resetScale: 'Reset zoom',
    maxLong: 'Maximum length',
    tempErr: 'Failed to add. Template position is incorrect or template is too large!',
    sendErr: 'Failed to send to workshop, please check if the tag template and plank data are correct before resending',
    someTips: 'You are currently using the trial version of cloud layout for irregular scrap/irregular nesting, please be careful to avoid production problems!',
    nestingTips: 'The limited-time free trial for [Advanced Irregular Nesting Layout] has expired. To continue using it, please contact sales to purchase!',
    frameDoorTip: 'The current layout detects merged skeleton gates. Note that before secondary processing, the edges of the skeleton gates must be sealed before cutting with the engraving machine!',
    cutOrderErr: 'Incorrect cutting order, please click to recalculate the knife point and cutting order!',
    holeSlotConflict: 'Board has hole-slot conflict or flying out small plate',
    exportSetting: 'Export Settings',
    currentTagTemp: 'Current Tag Template',
    specialPaibanErr: 'Some planks have special processes, re-layout is not supported for now!',
    moreResult: 'More Results',
    moreResultTip: 'The large panel has a slot for edge processing, so it will not participate in re-layout',
    batchBujian: 'Batch Patching',
    batchOperation: 'Batch Operation',
    batchEditPlankSize: 'Batch Edit Large Plank Size',
    editPlankSize: 'Edit Size',
    editWay: 'Edit Method',
    editByType: 'Edit by Type',
    editByPlankNumber: 'Edit by Plank Number',
    editContent: 'Edit Content',
    editContentTip: 'Please select the large plank type to edit',
    editContentTip1: 'Please select the large plank number to edit',
    editStart: 'Start',
    editEnd: 'End',
    bigPlank: 'Large plank',
    editSize: 'Size Changed To',
    bigPlankWidth: 'Large Plank Width',
    bigPlankHeight: 'Large Plank Length',
    bigPlankLengthMarking: 'Large Plank Length Marking',
    markedAs: 'Marked As',
    maxAddTen: 'Maximum 10 items can be added',
    minValue: 'Minimum value',
    differentKnifeErr: 'Large planks with different cutting knives are selected, size cannot be modified',
    noEditablePlank: 'No eligible large planks to modify',
    skipBrandPlankTip: 'There are {count} brand large planks in the selected range that do not support size modification and have been skipped',
    nonBrandToBrandTip: 'This part cannot be dragged onto a branded swatch plank!',
    brandToNonBrandTip: 'This part cannot be dragged onto a non-branded swatch plank!',
    brandToOtherBrandTip: 'This part cannot be dragged onto a different branded swatch plank!',
    editNo: 'No.',
    editAllPlank: 'All Large Planks',
    editBigPartSize: 'Large board size modification',
    disPlaySetting: 'Display setting',
    stored: 'Be in storage',
    onlySurplus: 'View Only Surplus',
    UnuseSurplus: 'Utilization rate does not include excess material',
    usePlankAdsorption: 'Plank adsorption function',
    dataDefaultCollapsed: 'Data is collapsed by default',
    unit: 'Pieces',
    cutSurplus: 'Cut Surplus',
    frontWarningTip: 'For double-sided processing gloss board: process <span class="font-style">matte surface</span> first, then process <span class="font-style">glossy surface</span>; &nbsp; For single-sided processing gloss board: process directly <span class="font-style">glossy surface</span>',
    selectTip: 'Please select planks that need to be patched below',
    plankKeyWordPlaceholder: 'Enter Part Name / No.',
    surplusStoreSuccess: 'Surplus stored successfully',
    editCutOrder: 'Edit cutting order',
    setCutPoint: 'Set knife point',
    specialPaibanChangeErr: 'Some planks have special processes, layout switching is not supported for now!',
    storedSuccess: 'Patching successful! Selected planks have been added to patch management!',
    noSurplus: 'No available surplus found',
    selectErrTip: 'Surplus planks cannot be patched, please select normal planks first',
    noRoomIDTip: 'This plank does not have a room ID, cannot be patched, please select other planks first',
    noPlank: 'Plank not found',
    noPaibanData: 'No layout data, unable to proceed',
    historyNameErr: 'Please enter the plan name',
    tempErrTip: 'Detected that you have not added templates for five/six-sided drilling, thus unable to export five/six-sided drilling processing files. Attention: After adding, you need to re-layout',
    changeDataTip: 'Attention: Detected changes in your data, whether to create a new history file, and save this change content?',
    upgrade: 'Upgrade',
    upgradeTip: ', you can click the button below to upgrade',
    plankOverEdge: 'Failed to download NC! Please check if there is overlap between planks or if the planks are outside the large plank',
    useSurplusTip: 'Whether to deduct surplus',
    noDataExport: 'No layout data available for export',
    noPlankExport: 'No planks available for export',
    lockTip1: 'Click to unlock, after unlocking you can',
    lockTip2: 'edit plank position and attributes',
    unlockTip1: 'Click to lock, once locked, it cannot be accessed',
    unlockTip2: 'edit the position and attributes of the small board',
    plankLockErr: 'This large plank has been locked and cannot be placed',
    lockPartEditTip: 'Plank is locked and cannot be edited',
    glassEquipmentTip: 'When the production line is a glass cutting machine, the plank cannot be moved',
    expandedTip: 'Special processing for panel slotting, editing operation not supported!',
    sameWidthPlankTip: 'The panel has a special grooving process and needs to be rearranged!',
    expandedArrangeTip: 'The panel has a special grooving process and needs to be rearranged!',
    dragErrTip: 'Cannot place, please check plank material, color, and thickness attributes!',
    subtleSaveTip: 'Changes have been made to the plank but not saved, do you want to exit?',
    rollTip: 'There are through holes/slots on the large plank, flipping is not recommended!',
    glossRollErr: 'Glossy planks are prohibited from rolling',
    lockDeleteErr: 'Plank is locked and cannot be deleted',
    deleteConfirmTip: 'Deletion operation cannot be undone',
    deleteContinueTip: 'Do you want to continue?',
    deleteConfirm: 'Please confirm deletion',
    selectPlankTip: 'Please select plank before performing this operation',
    storeFailTip: 'Surplus storage failed! Please check if there is overlap between planks or if the planks are outside the large plank',
    repeatStoreErr: 'The current surplus plank has been stored before',
    surplusStoreFail: 'Storage failed, please check if the plank is rectangular or L-shaped!',
    plankConfilictErr: 'Cannot place points here, will conflict with other planks',
    surplusErrTip: 'Cannot place points here, will produce an incorrect surplus',
    changeArrageSuccess: 'Successfully switched layout scheme',
    trialProduction: {
      trialProductionSample: 'Trial production sample cabinet',
      trialProduced: 'I have tried production',
      trialWarning: '{fontStyleStart}If{fontStyleEnd} due to your failure to verify the production of the sample cabinet, all losses and adverse consequences to yourself, others and cloud typesetting software will be borne by you personally',
      trialSlotTip: 'Please carefully check the size, depth, location, and position of the holes and grooves on both sides during trial production to ensure they are correct',
      trialSlotTip1: 'avoid cabinet mirroring',
      trialSlotTip2: 'problem',
      pleaseUploadTrial: 'Please upload the photo of the assembled sample cabinet for trial production',
      uploadTrial: 'Upload sample cabinet'
      },
    awaitPlankStore: {
      store: 'Board warehouse',
      notTip: 'No longer indicates that it is not in the library',
      justLookCurrent: 'Just look at the current order small board',
      notInPushStorage: 'Not put in storage',
      beInStorage: 'Be in storage',
      searchPlaceholder: 'Enter an order to search the library panel',
      plankUploading: 'The board is saved',
      oneClickStorage: 'One click to save to the waiting board library',
      notUsePlank: 'No board available',
      notPlank: 'No board is temporarily stored',
      dragPlankInHere: 'You can drag the board here to temporarily store the board',
      surplusCannotBeStorage: 'Surplus materials cannot be stored',
      plankHasBeenDeduction: 'The small board has been reduced or there is no original data, can not be stored',
      plankLoadErr: 'Failed to load board information. Procedure',
      taskTitle: 'Upload the board to be typeset in the library',
      dataGenErr: 'Data generation error',
      pushSuccess: 'Warehousing success',
      pushErr: 'An unknown error occurred. The repository failed',
      awaitBoxExistPlank: 'The inventory to be typeset is in the small board that has not been stored, it is recommended to operate after storage',
      pushAndOutput: 'Stock and export',
      mergeFrameDoorWholeTip: 'This part is a whole of the merged frame door component, and after storage, the system will automatically disassemble it into single block parts for management',
      checkPlankStatus: 'Checking board status...'
      },
    batchSetCut: 'Batch Set Cut Points',
    applyTo: '',
    ncDownloadLifeText: {
      checkData: 'Checking data',
      checkDone: 'Data check completed',
      checkDataText: 'Data Detection',
      loadSetting: 'Loading settings',
      settingLoadDone: 'Settings loaded',
      loadSettingText: 'Settings Loading',
      downloadNc: 'Downloading NC',
      ncDownloadDone: 'NC download completed',
      downloadText: 'Download NC',
      loadPreferenceSetting: 'Loading preference settings',
      PreferenceSettingLoadDone: 'Preference settings loaded',
      loadPreferenceText: 'Load Preferences',
      dealTemp: 'Processing template',
      TempDealDone: 'Template processing completed',
      dealTempText: 'Process Template',
      beBeingGenTagFile: 'Generating {fileType} file',
      genTagFileDone: '{fileType} file generated',
      genTagFileText: 'Generate {fileType} file',
      zip: 'Generating local zip file',
      zipDone: 'Local zip file generated',
      genZipText: 'Generate a compressed file',
      fileTypeText: 'Image'
      },
    surplusCommonTemp: 'Surplus Common Template',
    plankErrTip: 'The current material plan has small boards with no available large boards for layout!',
    brandPlankErrTip: 'The current material plan has brand parts with no available brand sheets for layout!',
    overSizeTip: 'Insufficient large boards or oversized',
    uselessPart: 'No usable small boards on the current large board, please re-layout',
    splitArranged: 'Too many small boards, please re-layout or arrange in batches',
    arrangedErrTip: 'Layout failed due to insufficient large boards or oversized small boards',
    knivesModalTitle: 'There are slots that cannot find tools',
    cannotDownloadByKnivesErr: 'Cannot download NC, the system detects that there are slots that cannot find tools',
    viewPart: 'View problem board',
    deductionModalTitle: 'Please select the deduction object',
    bujianDeduction: 'Deduct and supplement small boards',
    paibanDeduction: 'Deduction of temporary storage area small board',
    surplusDeduction: 'Deduction of surplus material large board',
    unlockPaiban: 'Unlock the remaining materials involved in typesetting',
    maintain: 'Maintain the lock of remaining materials involved in typesetting',
    lockModalText: 'Is there a need to rearrange the layout of the leftover large board that has been occupied by other orders',
    lockNewSModalText: 'The current surplus material board is occupied by other orders. Do you want to continue downloading NC',
    rePaibanWarn: 'The surplus large boards are occupied by other orders, and there is a shortage of available large boards. Please go to the material list to reformat',
    sawRePaiban: 'Attention: You are using a saw blade for cutting, and have added a layout for irregular plates. You need to reformat them to output NC files',
    togglePlankTip: 'The plank has a special grooving process and does not support front and back switching!',
    stepCuttingMsg: 'The layered cutting depth must be less than the board thickness',
    stepCuttingMsg2: 'The layered cutting depth can only be a number greater than 0',
    flipPlankTip: 'The flip operation is not allowed because the hole slot engraving process of the single-panel processing machine is enabled!',
    genNoCutTagNotSupportExportPic: 'Generate no-cut tag is enabled, export image is not supported',
    allSmallPlanksAreNoCutNotInLayout: 'All small planks are no-cut planks and do not participate in layout',
    canStillExportHoleSlotOrPrintTag: 'You can still export hole and slot processing files, or print tags',
    desMaterialNoCutNotSupportSwitchLine: 'Current production line has enabled designated small plank material no-cut, direct line switching is not supported',
    desMaterialNoCutSettingChanged: 'System detected that the setting for designated small plank material no-cut has been modified, please re-layout to ensure production accuracy',
    continueDownload: 'Continue Download',
    desMaterialNoCutErrorTip: 'There are holes/slots/shapes assigned to engraving machine processing in the planks with designated small plank material no-cut. All holes/slots/shapes in this download are assigned to 5/6-sided drill processing. Do you want to continue downloading the file?',
    clearReuseRelation: 'Click to clear reuse relationship',
    layoutReuseTip: 'Quickly replicate large board layout; board changes automatically clear the reuse relationship',
    hasBeenReused: 'Already reused',
    layoutReuse: 'Layout reuse',
    specialProcessNotSupported: 'The board has special processes and this operation is not supported',
    conflictNotSupported: 'Board conflict detected, this operation is not supported',
    noAvailablePlankForReuse: 'No available boards for reuse',
    noMatchingPlankFound: 'No matching board found',
    reuseBoard: 'Reuse {number}th board',
    influenceTip: {
      title: 'Features affecting optimization rate',
      empty: 'None',
      groupParams: 'Layout parameters',
      surplusNoRoll: 'Surplus material no flip',
      surplusCustomTrim: 'Individual trim value',
      otherPlateCustomTrim: 'Special board individual trim value',
      knifeDiameter: 'Knife diameter',
      surplusNoFlip: 'Surplus material no flip',
      surplusNotLayout: 'Surplus board not layout specified board',
      plankEdgeOff: 'Trim',
      surplusCustomTrim2: 'Surplus custom trim',
      other: 'Other features that may be affected',
      enabled: 'Enabled',
      plankThicknessStacking: 'Plank thickness stacking',
      edgePreMilling: 'Edge banding pre-milling',
      multiMaterialCuttingBlade: 'Multi-material cutting blade',
      sawSpecialShapePart: 'Irregular notch panels for saw cutting and engraving machines',
      longPlankCutting: 'Long plank secondary processing'
      }
    },
  paibanImg: {
    title: 'Nest Drawing Mgmt',
    exportCustomPaibanImg: 'Export custom layout diagram',
    customPaibanImg: 'Customized layout diagram',
    isCustomName: 'Customized layout name',
    template: 'Layout template',
    addTem: 'Add template',
    canvasIndexSearch: 'Large board number search',
    symbol: 'Layout icon recognition',
    frontSlot: 'Front slot',
    backSlot: 'Reverse slot',
    frontHole: 'Front hole',
    backHole: 'Back hole',
    printNum: 'Print one sheet of paper for maximum display',
    printUnit: 'A Layout Diagram',
    edit: 'Layout template editing',
    temName: 'Template name',
    rotate: 'Layout rotation',
    showOverflow: 'When the text overflows from the board, the identification line displays the data of the small board',
    showHoleSlot: 'Display hole slot information',
    bigPartCss: 'Style adjustment of large board layout diagram',
    partCss: 'Style adjustment of small board layout diagram',
    addTemTip: 'You can only add up to 10 typeset layout templates!',
    exportTip: 'Please select at least one layout template for export!',
    editSaveTip: 'Please confirm that all required fields are filled in before saving!',
    exportDXF: 'Export DXF',
    exportDxfGeneral: '2D General DXF',
    exportDxf3d: '3D Dedicated DXF',
    exportDxfGeneralTip: 'Suitable for manual processing, visual cutting, or checking layout results',
    exportDxf3dTip: 'Suitable for importing into third-party systems for production; supports Huiya laser cutting integrated machines'
    },
  historyPage: {
    matchErrBySpecialTip1: 'The following special boards can no longer find matching items, there will be problems with re-layout on the layout page',
    specialPlankInfoErrTip2: 'Error in obtaining special board information, which will affect the re-layout function of the layout page',
    download: 'Download Locally',
    allType: 'Save All',
    handleSave: 'Manual Save',
    specialPlank: 'Special',
    surplusPlank: 'Surplus',
    autoSave: 'Auto Save',
    allArrange: 'All Layout',
    searchPlaceholder: 'Search order name / layout batch / order number',
    saveHistoryName: 'Saved history name',
    trailProduction: {
      title: 'Trial production sample cabinet',
      lastTime: 'Last Trial Production Date',
      recordList: 'Trial Production Records',
      start: 'Start Trial Production',
      date: 'Time',
      outputFrom: 'Output Location',
      empty: 'No Data Available',
      record: 'Uploaded Trial Production Sample Cabinet Image Records',
      tip1: 'Attention: The current trial production order is using default production data',
      tip2: 'Attention: The current trial production order is not using the latest process settings parameters. You can go to the trial production room to save them again!',
      download: 'Download the processing file'
      },
    deleteTip: 'Are you sure you want to delete the following history records?',
    startDate: 'Start Date',
    endDate: 'End Date',
    lastWeek: 'Last Week',
    lastMonth: 'Last Month',
    lastSeason: 'Last Three Months',
    toArrangePage: 'Navigating to Layout Page',
    notArrangedTip: 'This record has not been arranged yet, please go to the material list first!',
    toMaterialPage: 'Navigating to Material List Page',
    lessSelectTip: 'Please select at least one record before performing this action',
    downloadNc: 'Download Processing File'
    },
  workShopPage: {
    warningTip: 'This feature is a limited-time trial. Please arrange your order production reasonably!',
    fileManager: 'Production File Management',
    selected: 'selected',
    suplement: 'Supplement Warehouse',
    size: 'Size',
    saveToStore: 'Add to Supplement Warehouse',
    enterArrange: 'Entering Layout...',
    deleteTip: 'After deleting this data, it cannot be restored. Are you sure you want to delete this data?',
    arrangeTip: 'Analyzing supplement data, please wait...',
    store: 'Supplement Warehouse',
    downloadFile: 'Download Production File',
    notBujianFile: 'Supplementary file not found',
    productLineDelete: 'This production line has been deleted, NC file download unavailable!'
    },
  basePlankManager: {
    saveTip: 'Attention: Press Enter to save',
    offsetSize: 'Trimming Size',
    overSizeTip: 'Auto use larger panels for oversized parts',
    addTip: 'If the board piece exceeds the allowed size during layout, a popup will appear to automatically add a special large sheet',
    defaultOversizePlankValue: 'Set the default size for oversized special sheets',
    onlyLayoutTooBig: 'Oversize panels only for oversize parts',
    settingRemark: 'Attention: the function here is adjusted to the right setting',
    searchPlaceholder: 'Search for board material/color',
    syncData: 'Synchronize cabinet data',
    syncDataM: 'Synchronize cabinet door data',
    deletePlank: 'Delete special large sheet',
    addPlank: 'Create new special sheet',
    matCodePlaceholder: 'Please select a board material',
    thickPlaceHolder: 'Please select a thickness',
    widthErr: 'Board width cannot be empty',
    heightErr: 'Board length cannot be empty',
    matCodeErr: 'Board material cannot be empty',
    colorErr: 'Board color cannot be empty',
    editPlank: 'Edit sheet',
    deleteTip: 'After deleting this data, it cannot be recovered. Are you sure you want to delete this data?',
    plankKnifeSelect: 'Original sheet cutting knife selection',
    plankKnifeSelectTip: 'When a plate part hits multiple rules, the priority of plate thickness is higher than that of plate material.',
    knifeSelectTip: 'Attention: This feature is not supported for nested layout',
    knife: 'Cutting Tool',
    matcodeInput: 'Please enter the board material',
    thickInput: 'Please enter the board thickness',
    default: 'System Default',
    unessential: 'This column is optional',
    emptyTip: 'Attention: If this item is not filled in, it will not be distinguished when matching the original sheet!',
    defaultUse: 'Default selection',
    editMatcode: 'Edit Material',
    syncTip: 'Will get data from {fromMc} and overwrite the original sheet management data in the existing cloud layout. Do you want to synchronize?',
    sameErr: 'The same data already exists',
    cancelDelete: 'Deletion canceled',
    syncErr: 'Synchronization failed',
    syncSuccess: 'Synchronization successful',
    syncDataTip: 'Synchronize ${fromMc} data',
    editErrTip: 'There are unfilled information, please check!',
    numberCheck: '{type} can only input numbers!',
    deleteStandardPlate: 'Removal of standard plate',
    createStandardPlate: 'New standard board',
    editStandardPlate: 'Edit Standard Plate',
    trimmingDimension: 'Trimming Dimension',
    front: 'Top',
    back: 'Bottom ',
    left: 'Left ',
    right: 'Right ',
    frontTrim: 'Top Trimming',
    backTrim: 'Bottom Trimming',
    leftTrim: 'Left Trimming',
    rightTrim: 'Right Trimming',
    customTrim: 'Custom Trimming Value',
    trimValue: 'Trim',
    notEmpty: '{type} cannot be empty!',
    edgeDir: 'Trimming ({type})',
    brandPlank: 'Brand Sheet',
    brandPlankTip: 'Note: Deletion and modification of brand sheets are performed in the Cabinet client board resource library',
    brand: 'Brand',
    supplier: 'Supplier',
    brandPlaceholder: 'Please select brand',
    supplierPlaceholder: 'Please select supplier',
    brandInput: 'Please input brand',
    supplierInput: 'Please input supplier',
    addBrandPlank: 'Add Brand Sheet',
    deleteBrandPlank: 'Delete Brand Sheet',
    editBrandPlank: 'Edit Brand Sheet',
    searchBrandPlaceholder: 'Search brand/supplier/material/color'
    },
  bujianAndStore: {
    bujianStore: 'Bujian Warehouse',
    awaitStore: 'Plank Awaiting Layout Warehouse',
    depositAwaitStore: 'Deposit into Awaiting Layout Warehouse',
    pushToAwaitStore: 'Push to Awaiting Layout Warehouse',
    useTwoTableArrange: 'Use Two Tables for Layout',
    confirmUseTwoTableTip: 'The selected small planks include both the Bujian and Awaiting Layout warehouses. Do you want to continue with the layout?',
    confirmAddPlankToAwaitStore: 'Are you sure you want to add the selected planks to the Awaiting Layout warehouse?',
    pushStoreSuccess: 'Successfully added to warehouse',
    dataGenErr: 'Data generation error',
    unknownErr: 'Unknown error occurred, failed to add to warehouse'
    },
  surplusPage: {
    surplusMaterial: 'Surplus Material List',
    surplusStore: 'Surplus Material Warehouse',
    recycleBin: 'Surplus Recycle Bin',
    recycleBinTip: 'Surplus material data will be automatically deleted after being in the recycle bin for more than 90 days',
    "deleteReason-0": 'Manual deletion',
    "deleteReason-1": 'Typesetting deduction',
    "deleteReason-2": 'Outbound via Guigui mobile operation',
    surplusShape: 'Surplus Shape',
    batchTransfer: 'Batch Transfer',
    createNewSurplusStore: 'Create New Surplus Warehouse',
    pushStoreSetting: 'Surplus Storage Settings',
    surplusStoreName: 'Surplus Warehouse Name',
    surplusStoreName2: 'Surplus Warehouse Name',
    addSurplusStore: 'Add Surplus Warehouse',
    inventoryCeiling: 'Inventory Ceiling',
    autoTransferTip: 'After deletion, surplus materials in the warehouse will be automatically transferred to the surplus material list',
    asIndexPushStore: 'Store in order according to warehouse storage conditions',
    pushToSurplusMaterial: 'Store in Surplus Material List',
    surplusStoreTable: {
      number: 'Number',
      name: 'Surplus Warehouse Name',
      quantity: 'Stored Surplus Quantity (pcs)',
      capacity: 'Surplus Inventory Ceiling (pcs)',
      rules: 'Rules for surplus material storage',
      remark: 'Remarks',
      operation: 'Operation'
      },
    editSurplusStore: 'Edit Surplus Warehouse',
    addSurplus: 'Add Scrap',
    importSurplus: 'Import Scrap',
    downloadSurplusTemplate: 'Download Scrap Import Template',
    batchExportSurplus: 'Export Current Scrap List',
    surplusBatchImportExport: 'Surplus Batch Import Export',
    surplusMaterialStorageCode: 'Surplus Material Storage Code',
    generateQRCodeSuccess: 'QR Code generated successfully',
    generateQRCodeFailed: 'Failed to generate QR Code',
    refreshQRCode: 'Refresh QR Code',
    refreshQRCodeFailed: 'Failed to refresh QR Code',
    cancelRefresh: 'Refresh cancelled',
    refreshQRCodeTip: 'Are you sure you want to refresh the QR code? The current QR code will become invalid after refresh.',
    refreshQRCodeConfirm: 'Confirm',
    refreshQRCodeCancel: 'Cancel',
    wechatScanTip: 'Open WeChat to scan QR code for manual surplus material storage',
    deletSurplus: 'Delete Scrap',
    editSurplus: 'Edit Surplus',
    surplusNoRoll: 'Enable Scrap Processing Without Re-rolling',
    type: {
      all: 'All Shapes'
      },
    allMatcode: 'All Materials',
    allThick: 'All Thicknesses',
    surplusName: 'Scrap Name',
    rectSurplus: 'Rectangular Surplus',
    LTypeSurplus: 'L-shaped Surplus',
    noMatchSup: 'No relevant data found',
    jumpTo: 'Jump to',
    page: 'Page',
    newMatcode: 'Create New Material',
    newColor: 'Create New Color',
    autoCreateColor: 'Press Enter to automatically create a color card',
    nameLimit: 'Surplus name can contain up to 10 characters',
    nameLimitNameErr: 'Surplus name cannot be empty',
    tempLongTip: 'Plank length can only contain numbers',
    minLongLimit: 'Short side length can only contain numbers',
    minLongEmptyTip: 'Short side length cannot be empty',
    minLongLimitMax: 'Short side length cannot exceed plank length',
    widthLimit: 'Plank width can only contain numbers',
    minWidthLimit: 'Short side width can only contain numbers',
    minWidthEmptyLimit: 'Short side width cannot be empty',
    minWidthLimitMax: 'Short side width cannot exceed plank width',
    thickLimit: 'Plank thickness can only contain numbers',
    thickEmptyLimit: 'Plank thickness cannot be empty',
    countInputLimit: 'Quantity must be a positive integer',
    countEmptyLimit: 'Quantity cannot be empty',
    remarkMaxlimit: 'Remarks can contain up to 50 characters',
    orderAddressMaxlimit: 'The source order address can be up to 100 characters',
    orderIdMaxlimit: 'The source order number can be up to 100 characters',
    createTime: 'Creation Time',
    deleteTime: 'Delete Time',
    deleteReason: 'Delete Reason',
    branchName: 'Surplus Material Warehouse',
    orderAddress: 'Source order address',
    orderId: 'Source order number',
    lockStatus: 'Locked State',
    lockOrder: 'Locked Order',
    enableSurplusLock: 'Enable the surplus material locking feature',
    isCloseSurplusLock: 'After the feature is turned off, all surplus materials will be unlocked. Do you wish to continue',
    confirm: 'Confirm to close',
    surplusTransfer: 'Transfer of surplus materials',
    targetSurplusStore: 'Target surplus material warehouse',
    enableSurLockTip: 'After activation, the remaining material used for each typesetting will be locked to prevent it from being occupied by other orders',
    addMainRule: 'Add main rule',
    surplusRules: 'Rules for surplus material storage',
    mainRulesTip: 'The relationship between master rules is either or, which means that as long as one master rule is met, the remaining materials will be stored in the warehouse',
    mainRulesTip1: 'After adding the rule, the remaining materials that hit the rule will be prioritized for storage in that warehouse, and when the warehouse is full, they will be stored in other available remaining material bins',
    rule: 'Rule',
    addSubRule: 'Add sub rules',
    subRuleTip: 'The relationship between sub rules is a AND, which means that all AND rules under the main rule need to be satisfied simultaneously in order to be stored',
    bigPlankMatCode: 'Large board material',
    bigPlankThick: 'Thickness of the large board',
    bigPlankColor: 'Large board color',
    greaterEqual: 'Greater than or equal',
    lessEqual: 'Less than or equal',
    capNumberCheck: 'The inventory limit can only be entered as an integer!',
    capEmptyCheck: 'The inventory limit cannot be empty!',
    surNameEmptyCheck: 'The name of the surplus material warehouse cannot be empty!',
    mainRuleLimit: 'The main rule has reached the upper limit',
    delMainRuleTip: 'Do you want to delete this main rule',
    matCodeEmptyCheck: 'The material of the large board cannot be empty!',
    thickEmptyCheck: 'The thickness of the large board cannot be empty!',
    textureEmptyCheck: 'The color of the large board cannot be empty!',
    enableWarehouseSecondCon: 'Enable secondary confirmation of surplus material storage',
    surplusWarehouseConfirm: 'Confirmation of surplus material storage',
    surplusWarehouseConfirm1: 'Warehouse confirmation',
    closeSurplusConfirm: 'Close inventory confirmation (can be reopened in the settings of the surplus material management page)',
    position: 'Position',
    nameRepeatTip: 'The current remaining material name already exists. Please modify it and re-enter the inventory',
    surLimitTip: 'The current surplus material warehouse has reached the upper limit or does not meet the storage rules',
    surFailTip: 'Storage failed, there are duplicate names of remaining materials or the storage capacity of the remaining material bin has reached the upper limit or does not meet the storage rules',
    surplusExistTip: 'Some remaining materials have already been stored, this operation failed',
    surplusExistTip2: 'The current remaining material has already been stored, this operation failed',
    currentPage: 'Current Page',
    totalPage: 'Select All'
    },
  printPage: {
    goto: 'Go immediately',
    surplusSizeTittle: 'Surplus Size Too Small Warning',
    surplusSizeErrTip: 'The surplus size is too small. Please go to the corresponding production line to set the minimum surplus size!',
    opacityTip: 'Technically supported by EZsort',
    opacityTip2: 'The current account has not purchased Smart Color Labels; if already purchased, please bind the cabinet account in the Color Label software',
    loadFontTip: 'Loading required font resource files, please wait',
    leftAlign: 'Left Align',
    rightAlign: 'Right Align',
    topAlign: 'Top Align',
    bottomAlign: 'Bottom Align',
    horizontalAlign: 'Horizontal Center Align',
    verticalAlign: 'Vertical Center Align',
    horizontalSplit: 'Horizontal Equal Division',
    verticalSplit: 'Vertical Equal Division',
    norTag: 'Normal Tag',
    surTag: 'Surplus Tag',
    genTag: 'Generate tag',
    all: 'Select all',
    deleteWarning: 'Warm reminder',
    print: 'print',
    defaultTemplate: 'Default Template（60 x 40）',
    editTemplate: 'Edit Template',
    deleteTip: 'Deleting this template cannot be restored. Are you sure you want to delete it?',
    tagSetting: 'Label Setting',
    rememberSetting: 'The setting will be remembered after modification',
    genCutingTag: 'Generate the label for the cutting board',
    genSurplusTag: 'Generate surplus tag',
    genPlankTag: 'Generate a large board tag',
    genPartTag: 'Generate Small Plate Labels',
    genNoCutTag: 'Generate no-cut plank tag',
    tagPosition: 'Label Position',
    tagPositionTip: '(Only the labeling machine needs to fill in the X/Y coordinates below)',
    Xposition: 'X coordinate',
    Yposition: 'Y coordinate',
    genPlankSuffix: 'The suffix of the file name for the large board label generation',
    arrangeMirror: 'Label image mirror',
    drillPlankBase: 'Five or six drill-and-place plate benchmarks',
    drillPlankBaseTip: 'Failed to retrieve base data for plank placement. Please try again later!',
    suitAuto: 'Label sorting adapts to automatic loading and unloading:',
    colorLabel: 'Generate color labels',
    colorRevert: 'Generate reversed color labels for small boards',
    displayEnAndZh: 'Display room/cabinet/panel name in English and Chinese',
    displayEnAndZhTip: 'Only supports default room/cabinet/panel names. This feature will not work after modifying to custom names',
    up: 'upward',
    down: 'downward',
    default: 'Default',
    printSetting: 'Print Settings',
    oneToMore: 'One page with multiple pages',
    perPage: 'Each',
    coloumn: 'column',
    tagMargin: 'Label Gap',
    coloumnMargin: 'Column spacing',
    specialMark: 'special mark',
    opacity: 'transparency',
    opacityTip3: 'BMP format images need to select true color to support transparency',
    suite: 'Adaptive',
    svgListTip: 'The small board label generation is not enabled. Please check the box on the left.',
    size: 'Size',
    lightSide: 'See the light side',
    locFrontSide: 'front side of the cabinet',
    openSide: 'Opening direction',
    extraTip: ' Attention: When using direct printing for the first time, please add a new sheet of paper with the same size and reversed length and width in the printer settings, and then use the new paper for printing. For example, the original paper size is 60×40, and the new paper size is 40×60',
    noMore: 'No more',
    prepareData: 'Preparing data...',
    genTagFile: 'Generating tags, please do not switch pages, minimize the browser, or scroll the tags up and down!',
    waitGen: 'Please wait for the tags to load completely before downloading',
    tempLoading: 'Loading tag template, please wait',
    front: 'Front',
    open: 'Open',
    toEdit: 'Go to Edit',
    simplifyOneCodeTip: 'Attention: The barcode properties set in this tag template do not support the "Simple Barcode" function, please modify the barcode properties (recommended barcode property: CODE128)',
    plankTemp: 'Small Plank Tag Template',
    surplusTemp: 'Surplus Material Tag Template',
    enableSubTag: 'Enable Sub Label',
    enableSubTagTip: 'You can go to More Settings > Small Panel Sub Label Settings > Set Effective Data Sources for Sub Label Generation. After enabling, a sub-label is generated only when the configured data source has a value on the sub-label; otherwise it will not be generated.',
    goSet: 'Go to Settings',
    mainTag: 'Small Panel Main Label',
    subTag: 'Small Panel Sub Label',
    downloadSubTagTip: 'The exported labels include a sub-label. The automatic labeling production line cannot generate sub-labels for now. Continue outputting?',
    embeddedSubTagTip: 'Embedded sub-label function is not supported. Please open the web-based cloud layout to use it.',
    subTagPerSaveTip: 'The secondary label permission has expired. Please close the secondary label and save again.',
    subTagPerexportTip: 'The exported production file contains paid secondary label permissions. This feature has expired and needs to be closed and output again.',
    tempNamePlaceHolder: 'Please enter the template name',
    editTip: 'You can edit the tag template by dragging the buttons from the left to the tag paper on the right according to your needs',
    oneCode: 'Barcode',
    image: 'Image',
    arrow: 'panah',
    editPage: {
      digitLimitation: 'digit limitation',
      title: 'Label Template Editing',
      reset: 'Restore default',
      exit: 'Exit Editing',
      tagInfo: 'Tag Information',
      tagName: 'Tag Name',
      tagSize: 'Tag Size',
      tagData: 'Tag Data',
      dragTip: 'Drag with the left mouse button to create a data tag',
      dataTip: 'Select data information from the property panel on the right',
      text: 'Text',
      dataSource: 'Data Source',
      graph: 'Graphic',
      typograpyPic: 'Typesetting diagram',
      barCode: 'Barcode',
      QRCode: 'QR Code',
      plankMark: 'Plate Mark',
      holeSlotPic: 'Hole and Slot Diagram',
      edgeBandPic: 'Edge Banding Diagram',
      visibleEdgePic: 'Visible edge',
      holeSlotPicZoom: 'Hole Slot Picture Zoom',
      rotateDeg: 'Rotation Angle',
      colorDeep: 'Color Depth',
      surplusMark: 'Surplus Material Mark',
      surplusSizePic: 'Surplus Material Size Picture',
      dataSize: 'Data Size',
      extraList: 'Additional List',
      QRCodeFormat: 'QR Code Format',
      formatQR: 'QR Format',
      formatDM: 'DM Format',
      locIndex: 'Cabinet Index',
      plankFrontSign: 'Panel Mark',
      genNCSuffix: 'Generate NC Suffix',
      table: 'Table',
      inputPlaceholder: 'Double-click to enter text',
      attribute: 'Attribute',
      fontFamily: 'Font Family',
      fontSize: 'Font Size',
      fontWeight: 'Font Weight',
      flipOverProcessing: 'Flip Over Processing',
      showSideMachiningSequenceDiagramBorder: 'Show Side Machining Sequence Diagram Border',
      showSideMachiningSequenceNumber: 'Show Side Machining Sequence Number',
      autoRow: 'Auto Wrap Text',
      rowMargin: 'Row Spacing',
      autoFontSize: 'Automatically Adjust Font Size on Overflow',
      statisticsDimension: 'Statistical Dimensions',
      noLimit: 'Unrestricted',
      sameOrderNo: 'Same Order',
      sameRoom: 'Same Room',
      sameWardrobe: 'Same Wardrobe',
      alignWay: 'Alignment',
      JustifyLeft: 'Left-Aligned',
      JustifyRight: 'Right-Aligned',
      JustifyCenter: 'Centered',
      otherOpration: 'Other Operations',
      attributeReset: 'Reset Attributes',
      barCodeSize: 'Barcode Size',
      installPic: 'Installation Diagram',
      plankCode2: 'Plate Barcode (noMark)',
      frontCode: 'Front Barcode',
      backCode: 'Back Barcode',
      orderRemark: 'Order Remark',
      NCFileName: 'Cutting File Name',
      NCFileNameTip: 'The NC file name should not contain Chinese characters and should not exceed 10 characters in length',
      showOpenSide: 'Show Door Opening Direction',
      limitFixed: 'Limit Decimal Places',
      showFrontHS: 'Show Front Hole Slot',
      showBackHS: 'Show Back Hole Slot',
      showPartEdge: 'Show Panel Edge Banding',
      showPlankSize: 'Show Plank Size',
      tempNamePlaceholder: 'Please enter the label name',
      deleteAreaTip: 'Please select the area to delete',
      suitShunt: 'Suit Shunt Setting',
      suitShuntTip: 'After selecting, the pieces of hole slots that have no subsequent processes after分流 will not generate barcodes',
      noHoleSlot: 'Show Barcode Even without Hole and Slot',
      rotate: 'Rotate Barcode',
      barcodeAtrribute: 'Barcode Attributes',
      imgSize: 'Image Size',
      graphStyle: 'Graph Style',
      noEdgeDisplay: 'Do Not Display if Edge is 0',
      allEdgeNoDisplay: 'Edge banding is not displayed',
      isShowDiffEdgeColor: 'Show different edge colors',
      hideSameEdgeColorAsPlank: 'Hide edge color when same as plank color',
      hideSameEdgeColorAsPlankTip: 'Not yet supported in embedded cloud layout',
      imgRotate: 'Image Rotation',
      circleD: 'Circle Frame Diameter',
      roomNo: 'Room Number',
      roomOrder: 'Cabinet Order (Sorted by Room)',
      alphabetically: 'Sort Alphabetically',
      numberOrder: 'Sort Numerically',
      specialMarkup: 'Special Marking Symbols',
      smallPlateMarking: 'Small plate marking',
      arrow: 'Arrow',
      triangle: 'Triangle',
      sixSideDrillPlankBase: 'Six-sided drilling placement base',
      boldSettingTip: 'PDF bold font is not supported',
      frontEdge: 'Display the front of the cabinet',
      visibleEdge: 'Display visible edge',
      lineCount: 'Number of characters per line'
      },
    autoSaveToHistory: 'Automatically saved to history!',
    firstPrintTip: 'When using direct printing for the first time, please add a new paper size with swapped length and width in the printer settings, then use the newly added paper for printing',
    tagDownloading: 'The label is downloading...',
    cutLaveEnd: 'Cut-off labels are generated behind each large slab',
    deleteTemplate: 'Delete Template',
    copyTemplateRenderUrl: 'Copy Template Link',
    noPermission: 'The imported template has closed the following features without permission',
    moreOperation: 'More Operation',
    importTemplate: 'Import Template',
    importTemplateLink: 'Paste the label template link address into the input box below, and the template can be imported',
    importTemplateLinkPlaceholder: 'Please enter the template link',
    noDeleteTemplate: 'The default template cannot be deleted',
    tip1: 'The current template has no copy link',
    tip2: 'The current template data link has been copied.',
    tip3: 'Failed to copy template link, please try again later',
    tip4: 'Unable to recognize the imported template link. Please download it again and import.'
    },
  fileManagerPage: {
    folderClassifyByTextureColorThickSize: 'Classify into different folders by material, color, thickness, and large board size (including labeling files)',
    notOpeFolderPermission: 'Unauthorized operation of directory',
    notFindFolder: 'The current directory cannot be detected on the current client',
    productLineUniversal: 'Universal for all production lines',
    effectCondition: 'This setting change will take effect only after re-layout',
    addPath: 'Add path',
    downloadPositionChangeByType: 'The download location for the generated files has been changed to {type}',
    isDeleteFolder: 'Are you sure you want to delete the used file storage location?',
    netWorkIsNotSafe: 'Your network environment seems to be unsafe, we cannot enable this feature, you can provide feedback to us',
    NotSupportBrowse: 'Your browser does not currently support this feature. Please download the latest version of the <a href="https://www.microsoft.com/en-us/edge/download" target="_blank">Edge</a> browser to use it.',
    notSupportDisk: 'System-level directories such as [Desktop] and [C Drive] cannot be selected',
    useFolderDownload: 'Production files are downloaded in an unzipped format',
    downloadPosition: 'Download file location',
    changeUseFolder: 'Change',
    folderNameSetting: 'Folder Settings',
    mainFolder: 'Primary Folder',
    exportNameSetting: 'Export Processed Files with Order Number Naming',
    fileMax: 'Maximum File Name Length',
    char: 'Characters',
    overTip: 'Excess part will not be displayed (Label graphics zip and json files will follow the primary folder naming)',
    example: 'Example',
    engravingFolder: 'Engraving Machine Folder',
    electronicSawFolder: 'Electronic Saw Folder',
    labellingFolder: 'Labeling Machine Folder',
    sideHoleDrillFolder: 'Side Hole Drilling Machine Folder',
    fiveDrillFolder: 'Five-Sided Drilling Machine Folder',
    sixDrillFolder: 'Six-Sided Drilling Machine Folder',
    PTPFolder: 'PTP Folder',
    labellingTagFolder: 'Labeling Image Folder',
    surplusFolder: 'Surplus file large board Settings',
    surplusBigPlankSetting: 'Spare material large board cutting files/label pictures/labeling files are placed separately',
    surplusBigPlankSettingTip: 'After opening, the remaining NC files, label pictures and labeling files will be placed in a separate folder',
    folderMergeSetting: 'Folder Merging Settings',
    folderMerge: 'Folder Merging',
    mergeName: 'Merged Name',
    subMergeFolder: 'Merge into subfolders based on material, color, and thickness:',
    subFolderName: 'Subfolder Name',
    splitChar: 'Separator',
    splitTip: '(Unsupported characters include / : ? < > | . ” *)',
    folderAutoAdd: 'Automatic Increment Starting Value for Folder Count',
    resetTip: '(Resets to the starting value at midnight every day)',
    emptyErrTip: 'Information cannot be empty',
    repeatErrTip: 'File name duplicate',
    mergeDataTip: 'The board material color thickness length and width or file number increase or board material color thickness must exist',
    engravingFileSetting: 'Carving machine file settings',
    engravingSplitZF: 'Place the front/back files of the engraving machine in different folders',
    engravingSplitZFTip: 'Suitable for 123 automatic labeling machines,',
    engravingSplitWorkstation: 'Carving machine by workstation folder',
    engravingSplitWorkstationTip: 'Note: Only supported for engraving machines and sawing engraving machines',
    holeFileSetting: 'Punch file settings',
    holeFileSingle: 'Punching files are placed separately in folders according to different orders'
    },
  moreSettings: {
    generalSetting: 'General setting',
    outSyncTip: 'When the cloud typesetting original film data is not synchronized with the cabinet cabinet, a pop-up window is generated',
    secondarySwitchShow: 'The secondary content of the switch control in the engraving machine setting is still displayed after the switch is turned off',
    isFrameDoorTip: 'Generates prompt pop-ups when processing frame doors',
    exPaibanTip: 'Generates prompt pop-ups when using irregular scrap/irregular nesting typography',
    isDesMaterialNoCutTip: 'For specified small board materials that are not cut, when there are holes/slots/shapes assigned to the engraving machine, a prompt pop-up window will be generated',
    surpTagThresholdTextHalf1: 'When the area of the surplus material (not cutting surplus material) is less than',
    surpTagThresholdTextHalf2: ' do not generate a surplus material label',
    innerShapeToolMatch: 'Carving machine automatically selects the appropriate tool for internal irregular shapes',
    innerShapeToolMatchTip: '（When the carving machine processes internal irregular shapes smaller than the cutting tool diameter, the size error cannot be processed. This function can be enabled to solve the problem）',
    innerShapeToolMatchTip2: 'Attention: After enabling, the carving machine will use the smallest slot cutter, please set the "tool length" and "maximum single processing depth" of the smallest slot cutter carefully, only valid in cloud settings',
    surNotLayout: 'Define the excess material large board without arranging specified board components',
    surNotLayoutTip: 'After activation, 1. The leftover large board cannot be arranged, and the name of the small board containing the name below. 2. During typesetting, you can choose whether this function will be effective for this typesetting',
    addPlank: 'Add board name',
    addPlankTip: 'Add at least one board name',
    thisInput: 'Enter here',
    surNotLayoutMat: 'Surplus materials are not arranged on designated small boards',
    subTagSetting: 'Small Panel Sub Label Settings',
    subTagDataSource: 'Set Effective Data Sources for Sub Label Generation',
    subTagDataSourceTip: 'After enabling, you can add data sources that control sub-label generation. A sub-label is generated when the sub-label contains that data source and the data source has a value.',
    addSubTagDataSource: 'Add Data Source',
    addSubTagDataSourceTip: 'Duplicate data sources are not allowed',
    addSubTagDataSourceTip1: 'Please add at least one data source',
    addSubTagDataSourceTip2: 'Data source cannot be empty, please select',
    reuseMatchingPlankName: 'Reuse matching by plank name',
    reuseMatchingPlankNameTip1: 'When this feature is disabled, layout reuse matches panels with the same material, color, thickness, dimensions, texture, and high-gloss properties',
    reuseMatchingPlankNameTip2: 'When this feature is enabled, in addition to the above matching conditions, plank name matching is also added'
    },
  lineManager: {
    add: 'Add Production Line',
    engraving: 'Cutting Equipment',
    holeSlotEquip: 'H&S Equipment',
    workSetting: 'Processing Settings',
    noUse: 'Not Enabled',
    warningTip: '* Attention: After setting the following functions, please do not save on the cabinet client device docking page to avoid resetting the parameters!',
    engravingSetting: 'Cutting Machine Settings',
    workWay: 'Processing Method',
    cutedSpecial: 'Special Holes and Slots for Processing:',
    noWork: 'This option does not apply to the default template for five/six-sided drilling',
    onlyCut: 'Only Cutting',
    onlyFrontHoleSlot: 'Only Process Front Holes and Slots of Boards',
    onlyHoleSlot: 'Only Process Front and Back Holes and Slots of Boards',
    sideHoleSetting: 'Side Hole Machine Settings',
    cutHoleSlot: 'Processed Holes and Slots',
    minSize: 'Short side dimension',
    maxSize: 'Long side dimension',
    minSize2: 'All on the mm board',
    minSize3: 'And the Alien Part',
    onlyFrontHoleSlotTip: 'Only Process Front Holes and Slots of Boards',
    onlyFrontHoleSlotTip2: 'Not Include Side Holes and Slots',
    holeAndSlot: 'Holes and slots',
    empty: 'Empty',
    singleHole: 'Single Hole',
    singleSlot: 'Single Slot',
    diameterRange: 'Hole Diameter Range',
    hDeepRange: 'Hole Depth Range',
    widthRange: 'Slot Width Range',
    sDeepRange: 'Slot Depth Range',
    to: 'to',
    specialHS: 'Special Holes, Slots, and Shapes',
    allowRoll: 'Allow Cutting Machine to Process Special Holes and Slots by Turning Over the Board',
    engravingPath: 'Process Special Parts of Boards on the Cutting Machine',
    curve_range: 'Long side of special shape part greater than',
    curve_range2: 'all special shape parts of the board',
    curveArea: 'Area of irregular shape',
    drillSetting: 'Five/Six-Sided Drilling Settings',
    engravingCuted: 'Processed Holes and Slots on the Cutting Machine for Five/Six-Sided Drilling',
    engravingCutedSpecial: 'Processed Special Parts of Boards on the Cutting Machine for Five/Six-Sided Drilling',
    genCuttingPath: 'Generate Cutting Data',
    otherCuted: 'Holes and slots processed by other equipment on the five/six-side drill',
    noGen: 'Do Not Generate',
    genCut: 'Generate and Process',
    genNoCut: 'Generate But Do Not Process',
    cutTip: 'Attention: This option only applies to custom five/six-sided drilling files',
    maxShortSize: 'Maximum Short Side Length',
    maxLongSize: 'Maximum Long Side Size',
    normalSlot: 'Regular Slot',
    specialSlot: 'Special Slot',
    combinSetting: 'Combined Equipment Settings',
    allowShortSize: 'Allow Short Side Length',
    equipment1: 'Equipment 1',
    equipment2: 'Equipment 2',
    noSameTip: 'Attention: The two equipment cannot be the same',
    workRange: 'Processing Range for Equipment 1',
    rangeWarning: 'Attention: Only the processing range for Equipment 1 can be set. All non-Equipment 1 processing ranges will be processed on Equipment 2. Please proceed with caution!',
    deleteWarning: 'After deleting this production line, it cannot be recovered (all settings for this production line will be deleted). Are you sure you want to delete this production line?',
    top: 'Top',
    inputCheck: 'The minimum value of {msg} cannot be greater than the maximum value',
    lockTip: 'The production line is locked and cannot be operated!',
    reNameTip: 'The default production line cannot be renamed',
    permissonTip: 'Your identity has expired. Please reopen this page from the cabinet!',
    permissonErr: 'You do not have this permission. Please upgrade your account version!',
    permissionOneMacErr: 'You currently have access to {idx} production line for the integrated machine. If you need to add more, please contact the salesperson!',
    permissionSawErr: 'You do not have permission to use the cutting machine, please contact the after-sales service to purchase the full-aluminum cutting and disassembly production supplement package!',
    getAuthError: 'Failed to obtain device permissions!',
    sawAddNumber: 'Your available e-saw production lines have been used up. If you need to increase the limit, please contact sales!',
    newLine: 'New Production Line {idx}',
    deleteCheck: 'Cannot delete all',
    deving: 'Under Development',
    combinTip: 'Please set up the combined equipment below',
    noUseEquip: 'Processing Equipment Not Enabled',
    equipmentSelectTip: 'When selecting combined equipment with a cutting machine, the cutting equipment cannot be set to an electronic saw',
    lineLoading: 'Data Loading',
    strenchType: 'Straightener Slot Type',
    aioProcessTip: 'You have enabled the "All-in-One" device, processing mode defaults to processing both sides of the planks with holes and slots',
    aioProcessTip2: 'After enabling the All-in-One, special holes and slots will be processed in the carving machine section',
    aioProcessTip3: 'Attention: This function is not compatible with carving machines that have enabled the XY axis swap function. Please use with caution',
    specialHoleTip: 'Attention: When using the above "special hole slot processing" function, please set the "through-hole drilling method" and "through-slot penetration method" to drill through at once',
    specialHoleTip2: 'Attention: When using the above "special hole slot processing" function, please set the carving machine’s "through-hole drilling method" and "through-slot penetration method" to drill through at once',
    fiveSixNotTake: 'This option does not apply to the default templates for five/six-sided drilling',
    onlyFrontSide: 'Process front side only',
    onlyBackSide: 'Process back side only',
    less: 'Less than',
    equal: 'Equal to',
    greater: 'Greater than',
    or: 'Or',
    and: 'And',
    bothFrontBack: 'Process both front and back sides',
    shareDataErrTip: 'This data is applied by {operatorPhone} , IP: {actionIP}',
    restoreParams: 'Restore parameters',
    loadMore: 'Load more',
    currentCombinationEquipment: 'The currently selected combination equipment does not allow the cutting equipment to switch to a glass cutting machine',
    selectEquipmentType: 'Please select the equipment type',
    ruleRemark: 'Rule Remark',
    remarkPlaceholder: 'This is a note information, can note this rule for processing which technology, avoid forgetting',
    onlyNoSideHoleSlotSmallPlank: 'Only Small Boards Without Side Holes/Slots'
    },
  cuttingDock: {
    title: 'Cutting Machine Docking',
    autoStockCode: 'Automatic loading and unloading code',
    stationStart: 'Station Start',
    stationStartCode1: 'Station 1 Start Code',
    stationStartCode1Placeholder: 'Enter Station 1 Start Code',
    stationStartCode2: 'Station 2 Start Code',
    stationStartCode2Placeholder: 'Enter Station 2 Start Code',
    stationEnd: 'Station End',
    stationEndCode1: 'Station 1 End Code',
    stationEndCode1Placeholder: 'Enter Station 1 End Code',
    stationEndCode2: 'Station 2 End Code',
    stationEndCode2Placeholder: 'Enter Station 2 End Code',
    frontBackStart: 'Front and Back Start',
    frontBackEnd: 'Front and Back End',
    frontStartCode: 'Front Start Code',
    frontStartCodePlaceholder: 'Enter Front Start Code',
    frontEndCode: 'Front End Code',
    frontEndCodePlaceholder: 'Enter Front End Code',
    backStartCode: 'Back Start Code',
    backStartCodePlaceholder: 'Enter Back Start Code',
    backEndCode: 'Back End Code',
    backEndCodePlaceholder: 'Enter Back End Code',
    plankStart: 'Plank Turn Start',
    plankEnd: 'Plank Turn End',
    plankRollCode1: 'Station 1 Turn Code',
    plankRollCode1Placeholder: 'Enter Station 1 Turn Code',
    plankRollCode2: 'Station 2 Turn Code',
    plankRollCode2Placeholder: 'Enter Station 2 Turn Code',
    autoBaitingCode: 'Auto Feeding Code',
    autoBaitingCode1: 'Station 1 Feeding Code',
    autoBaitingCode1Placeholder: 'Enter Station 1 Feeding Code',
    autoBaitingCode2: 'Station 2 Feeding Code',
    autoBaitingCode2Placeholder: 'Enter Station 2 Feeding Code',
    thickMarkPermission: 'You currently do not have Big Plank Thickness Mark permission. Please contact sales to purchase before use',
    thickMark: 'Big Plank Thickness Mark',
    preStartEquipment: 'Pre-Start Equipment',
    firstKnifePreCode: 'First Knife Pre-Start Code Advance',
    secondKnifePreCode: 'Second and Subsequent Knifes Pre-Start Code Advance',
    rowInsert: 'Row Insert',
    pumpPause: 'Vacuum Pump Pause',
    pumpPauseTip: 'Attention: Simplex equipment is required to fill in the same "Automatic feeding code" and "Double-sided Machining front Note Code" for both stations 1 and 2.',
    pumpPause2Tip: 'Attention: Simplex equipment needs to be filled with the same "vacuum pump pause code" for both stations 1 and 2.',
    pumpPauseCode1: 'Station 1 Vacuum Pump Pause Code',
    pumpPauseCode1Placeholder: 'Please enter the vacuum pump pause code for Station 1',
    pumpPauseCode2: 'Station 2 Vacuum Pump Pause Code',
    pumpPauseCode2Placeholder: 'Please enter the vacuum pump pause code for Station 2',
    annotationCode1: 'Annotation code for double-sided processing (front) of workstation 1',
    annotationCode1Tip: 'Suitable for equipment with different commands for automatic loading (front)',
    annotationCode1Placeholder: 'Enter the annotation code for double-sided processing (front) of workstation 1',
    annotationCode2: 'Annotation code for double-sided processing (front) of workstation 2',
    annotationCode2Placeholder: 'Enter the annotation code for double-sided processing (front) of workstation 2',
    upSpeedTip: 'Please enter the common edge acceleration speed',
    cutThickTip: 'Please enter the common edge cutting thickness',
    sizeErrTip: 'Please set the correct size for the exported layout in the labeling machine!',
    offEdgeKnifeDiameter: 'Please enter the trimming knife diameter',
    slowDownSpeedTip: 'Error in entering the deceleration parameter for cutting corners',
    permissionErr: 'This is the free version, saving is not allowed',
    labellingTempErr: 'Please select a labeling machine template',
    autoRollInputTip: 'To enable automatic label rotation, a valid value must be entered',
    offlineTempFormat: 'The current labeling machine file format has been discontinued. Please confirm',
    autoStockCode1: 'Station 1 automatic feeding code',
    autoStockCode1PlaceHolder: 'Enter the automatic feeding code for Station 1',
    autoStockCode2PlaceHolder: 'Enter the automatic feeding code for Station 2',
    autoStockCode2: 'Station 2 automatic feeding code',
    pauseCode: 'Pause code',
    pauseCodePlaceHolder: 'Enter the pause code',
    cuttingToolMaxDepthTip: 'The maximum machining depth of the {errKey} knife in the knife library cannot be greater than the length of the cutting tool',
    cuttingParams: {
      title: 'Cutting Parameters',
      stationWidth: 'Station Width',
      stationWidthTip: 'When using surplus large panels, the width direction can only be arranged within the set size range',
      holeSlotMainSide: 'Concentrated Face of Holes and Slots',
      holeMainSide: 'Concentrated Face of Holes',
      slotMainSide: 'Concentrated Face of Slots',
      workPriority: '(Functional Priority: The face with punching holes and slots follows the unpunched holes and slots on the small board > Special slots set in the slot diversion are prioritized on the front side of the large panel > Concentrated Face of Slots > Concentrated Face of Holes)',
      holeSlotSet: 'Punching slot processing settings',
      hingeRollWork: 'Straightener and Hinge Cup Holes are Processed on the Reverse Side of the Large Board',
      followWork: 'The face with punching holes and slots follows the unpunched holes and slots on the small board',
      autoMatchSide: 'Allocate Front and Back Holes and Slots Proportionally',
      backHSRate: 'Proportion of Holes and Slots on the Reverse Side',
      matchTip: '(This setting will not be effective for high-gloss boards, or for opening and calculating abnormal layout plans, or for pattern matching)',
      specIalHoleAndSlotSurface: 'Custom definition of machining surfaces for special slots and holes',
      specialRuleTip: 'This field cannot be empty.',
      specialSlotsHoles: 'Hole and slot type',
      holeType: 'Hole Type',
      specialRules: 'Rule',
      normalHole: 'Conventional hole',
      normalSlot: 'Conventional slot',
      holeDiam: 'Hole diameter',
      slotLongSide: 'Slot long side',
      slotShortSide: 'Slot short side',
      FixedmachSurface: 'Fixed machining surface',
      deleteRuleTip: 'Whether to delete this rule',
      blankFront: 'Front side of the large board',
      blankBack: 'Back side of the large board',
      addRules: 'Add rule',
      addRulesTip: 'When the same small board matches multiple rules, the rule with the earliest effective sequence number takes effect, You can drag any row to change the rule order',
      highGlossSetting: 'High-Gloss Board Settings',
      heighGlossFront: 'Small Boards with High-Gloss Faces are Arranged on the Large Board During Layout',
      highGlossPlankNoRotate: 'High-Gloss Board No Rotate',
      highGlossAutoRoll: 'Only large boards with back holes and slots automatically flip',
      highGlossAutoRollTip: "<span class='color-o-4'>(After enabling, only large boards with back holes and slots will automatically flip during layout, becoming single-sided boards. Use with the custom file name \"Flip and place high-gloss surface board\" data)</span>",
      customHighGlossReverse: 'Flip and place high-gloss surface board',
      sideSlotPut: 'Place Slots Close to the Edge',
      optimize: 'Undergoing Functional Optimization',
      sysDefault: 'System Default',
      plankInSide: 'Inner Side of Large Board',
      plankOutSide: 'Outer Side of Large Board',
      specialNotWork: 'This feature does not apply to abnormally shaped board pieces',
      commonSide: 'Common Edge Cutting',
      commonSetting: 'Common edge setting',
      plankThickRange: 'The Thickness of the Board Piece is Less than or Equal to',
      useCommonSide: 'Use Common Edge Cutting When',
      zeroTip: 'The layout gap needs to be manually changed to 0, and the tool will lift when processing to the already cut edge to skip it, after enabling this feature, oblique down-cutting processing will not be supported.',
      useTip: 'After enabling this feature, oblique down-cutting processing will not be supported. Please note!',
      commonSpeed: 'Common Edge Acceleration',
      highSpeed: 'High-Speed Milling Speed',
      min: 'Minute',
      notWorkTip: 'Common edge acceleration will not be effective when the board processing meets the conditions for common edge cutting',
      changeStartPoint: 'Double-Station Starting Point Switching',
      changeStartPointTip: 'After enabling double-station starting point switching, it is not compatible with the XY axis swap function. Please use cautiously.',
      flatOffset: 'Machine Plane Offset',
      xRowChange: 'X-Axis Coordinate Reference Swap',
      bigplankPointChange: 'Swap the reference coordinates on the back of the large board',
      reverseXRowChange: 'Swap X-Axis coordinates',
      changebigplankPointTips: 'After enabling this feature, it is not compatible with the "XY axis swap" and "dual station start point switch" functions. Please use cautiously.',
      reverseYRowChange: 'Swap Y-Axis coordinates',
      plankMirrorTip: 'Use this feature when mirroring board pieces processed on the cutting machine',
      notSameSize: 'Different Sizes for Double-Station Tables',
      maxSize1: 'Maximum Size for Station 1',
      notSameSizeTip: 'After enabling different sizes for double-station tables, it is not compatible with the double-station file merging function. Please use cautiously.',
      maxSize2: 'Maximum Size for Station 2',
      autoSelectTip: 'When using this feature with different sizes for the two tables of a double-station machine, it will automatically select the corresponding station for processing large boards.',
      bigFlatLimit: 'The large station only processes large boards that cannot be processed by the small station:',
      surplusSetting: 'Scrap Settings',
      surplusPosition: 'Scrap Placement Position',
      cutHoleWay: 'Cutting and Drilling Method',
      knifeFlat: 'Knife Reference Plane',
      flat: 'Table Surface',
      plankFlat: 'Large Board Surface',
      freeHeightZ: 'Z Height When Idle',
      relativeHeight: 'Relative Height to the Upper Surface of the Large Board',
      cutDeepZ: 'Cutting Depth in Z Axis',
      cutDeepH: 'Through-Hole Drilling Method',
      setDisableDoubleSidedThroughHole: 'Set disable double-sided through hole drilling',
      addHolesToRulesDisableDoubleSided: 'After adding the corresponding through-holes (holes drilled all the way through) to the rules below, flipping twice to drill through will not take effect',
      onceThrough: 'Drill Through Once',
      rollThrough: 'Drill Through by Turning Over Twice',
      cutDeepS: 'Through-Slot Drilling Method',
      plankCutDirection: 'Cutting Direction of Small Boards',
      clockDirSwitch: 'Custom Milling Hole/Slot and Internal Profile Cutting Direction',
      millHoleSlotDir: 'Milling Hole/Slot Direction',
      millInternalCurveDir: 'Internal Profile Cutting Direction',
      sDirection: 'Clockwise',
      nDirection: 'Counterclockwise',
      curveReplenish: 'Arc Interpolation Instruction for Cutting Arc-Shaped Boards',
      curveReplenishTip: 'Use this function when sawtooth appears during cutting of arc-shaped pieces',
      noGen: 'Do Not Generate G17/G18/G19 Plane Instructions',
      arcInstruction: 'Arc machining command prefix',
      example: 'example',
      arcExample: 'G17G03 X100 Y100',
      curveCutTip: 'Arc cutting is represented by I and J',
      coverRate: 'The Overlap Rate for Milling Slots Is:',
      roughTip: 'Use this function when there are burrs inside the slot during milling',
      clearCurve: 'Automatic Rounding of Slots That Are Not Completely Milled Through:',
      curveUseTip: 'Select this function when rounding is needed during slot milling. Note that this function does not apply to connectors.',
      slotCutWay: 'Slot Milling Toolpath',
      outToIn: 'Mill Slots from Outside to Inside',
      inToOut: 'Mill Slots from Inside to Outside',
      zShapProcess: 'Zigzag through groove',
      zShapProcessTip: 'Only for the front and back pull through slot milling, the tool path overlap rate defaults to the tool radius',
      zSlotCuttingOverlapRate: 'Z-shaped slot cutting overlap rate',
      zSlotCuttingOverlapRateTip: 'Current overlap rate may cause processing speed to slow down, please try again after the machine is started.',
      slotWorkLimit: '(Only Effective When the Number of Layers for Slot Milling > 1)',
      minKnifeChange: 'Processing Reduce Knife Change',
      preventBreakage: 'Edge Slot Separator Breakage Prevention',
      preventBreakageTip: 'This setting only applies to slots on the front side during nesting, and can be used with "Custom definition of machining surfaces for special slots and holes"',
      preventBreakageTip1: 'Can solve the situation where the slot is too close to the edge of the panel, and the separator bar (the remaining connection part) at this position will easily break due to stress concentration when cutting',
      preventBreakageDistance: 'Distance from Panel Edge',
      preventBreakageLength: 'Edge Section Length',
      preventBreakageSlot: 'slots',
      preventBreakageCutDeep: 'First Cut Depth',
      workSpeedOp: 'Processing Speed Optimization',
      obliqueCut: 'Oblique Downward Cutting During Cutting',
      obliqueCutTip: 'When the plate thickness is not specified, it takes effect for all plate thickness small plates',
      obliqueThickLabel: 'Custom Oblique Cutting Effective Thickness',
      obliqueThick: 'Custom Oblique Cutting Thickness',
      backObliqueThick: 'Custom Backside Trimming Oblique Cutting Thickness',
      effectiveThickness: 'Effective Thickness',
      effectiveThicknessTip: 'Effective Thickness cannot be empty, please enter!',
      effectiveThicknessDuplicateTip: 'Effective thickness cannot be duplicated, please modify',
      obliqueCutData: 'Oblique Downward Cutting Distance',
      backOblique: 'Oblique Downward Cutting for Backside Trimming',
      obliqueSpeed: 'Oblique Cutting Speed',
      obliqueSpeedTip: 'Cutting down and backside trimming',
      arcSpeed: 'Curve Processing Speed',
      cuttingPreDistance: 'Distance to Advance Before Cutting',
      backKnife: 'Deceleration Before Cutting Ends',
      openKnifeSpeed: 'Speed for Cutting End',
      retractionCompensation: 'Retraction Compensation',
      retractionCompensationTip: 'Maximum value 20',
      cutCornerSlow: 'Deceleration When Cutting Corners',
      addRow: 'Add row',
      bettwenDistance: 'Distance Before and After Corners',
      cuttingSpeed: 'Cutting Speed',
      stepCutting: 'Layer Cut',
      splitSlot: 'Cut Slots in Two Steps',
      splitPlank: 'Cut Small Boards Twice',
      splitPlank2: 'Cut Small Boards Twice',
      minSafeThick: 'Thickness Greater Than',
      splitPlankTip: '(Irregular boards do not take effect for this feature)',
      splitPlankTip2: '(Incompatible: Knife Compensation)',
      cutPlankMethod: 'Cut Plank Method',
      cutPlankMethodTip: 'Four Sides Cut Twice',
      cutPlankMethodTip2: 'Only the last side cut twice',
      specialShapCut: 'Special Shape Cutting Twice',
      specialShapCutTip: '(After enabling, all irregular boards will be cut twice)',
      bridgeRetention: 'Bridge Retention Point Method',
      bridgeRetentionTip: '(Note: 1. This feature does not currently support external irregular boards. 2. It does not support oblique downward cutting. 3. The minimum part size for generating connecting bridges is 30mm.)',
      bridgeRetentionDesc: 'Helps prevent board jitter or run-off when large hollow areas inside the board cause insufficient support for the cutting path.',
      bridgePunchArea: 'Punched area exceeds total area',
      bridgeSize: 'Bridge Size',
      bridgeGenMethod: 'Generation Method',
      bridgeAddTip: 'Add up to 10 items',
      bridgeCount: 'Number of Bridges',
      bridgePlankLength: 'Board Length (L)',
      maxWH: 'Length or Width less than',
      areaLimit: 'And Area less than',
      secondDeep: 'Second Cutting Depth',
      splitPlankThickSetting: 'Sizing layered cutting settings',
      saveCustomSpeedTip: 'Processing speed cannot be empty',
      saveLayeredCuttingTip: 'The sum of the three layered cuts must be equal to the thickness of the plate',
      saveLayeredRepeatTip: 'It is not recommended to set different layered data for the thickness of the highlight attribute of the same material, please delete the redundant data!',
      splitPlankThick: 'Layered Cutting for Different Board Thicknesses',
      movePlankSetting: 'Anti-slip board settings',
      newCutSequence: 'New cutting algorithm',
      newCutSequenceText: 'By default, the center of the large slab has the strongest vacuum suction, and the small slabs in this area are cut last',
      positionTip: 'Click on the corresponding area to select',
      suctionPosition: 'Vacuum strong suction position',
      strongArea: 'Strong suction area',
      minSuctionPlank: 'Minimum suction board',
      safeWidth: 'Width',
      safeHeight: 'Length',
      safeTip: 'Will cut first if the board cannot be held securely',
      scattered_layout: 'Small board scatter layout',
      lastCutPointEnable: 'Customize cutting point for last-cut part on large board',
      lastCutPointEnableTip: 'When enabled, the cutting point of the last cut small board on each large plank will be generated according to the set point position',
      lastCutPoint: 'Cutting point position',
      lastCutPointTip: 'When enabled, the last cut small board on each large plank will use this cutting point',
      leftTop: 'Top-left',
      rightTop: 'Top-right',
      leftBottom: 'Bottom-left',
      rightBottom: 'Bottom-right',
      specifyTheMaterial: 'Specify the material',
      shapeSecondCutenable: 'Secondary cutting of profiled plate',
      addMaterial: 'Add material',
      plankMaterial: 'Panel material',
      specifyTheMaterialTip: 'After enabling, the secondary cutting function will only take effect for the panels that meet the material requirements of the table.',
      dispersePaibanTipOne: 'After enabling, at least one panel that meets the minimum size that can be absorbed will be arranged on each large board',
      dispersePaibanTipTwo: 'Attention After using, the amount of large boards may increase',
      totalThickLimit: 'The Sum of Three-Layer Cutting Must Equal the Thickness of the Board Piece',
      offsetFollowStep: 'Trimming Also Follows Layered Cutting',
      longPlankTip1: '1. After enabling or disabling this feature, layout records saved in history require re-layout when downloading NC.',
      longPlankTip2: '2. After enabling this feature, you must set the vacuum pump pause code in [Cutting Machine Docking - Vacuum Pump Pause]; otherwise bending when cutting long boards cannot be resolved.',
      longPlankTip3: "3. The filter conditions enabled below are validated sequentially by level; only boards that meet the previous level's filter conditions can proceed to the next level's filter conditions for evaluation.",
      secondCutting: 'Secondary cutting object',
      normalPlank: 'Regular board',
      normalPlankTip: 'Regular board: boards such as cross and vertical partitions in the cabinet body, and boards added directly in the material cutting list, excluding cabinet doors.',
      designatedTarget: 'Designated objects',
      filterLevel1Label: 'Level 1 filter',
      filterLevel1Category: 'board type',
      filterLevel2Label: 'Level 2 filter',
      filterLevel2Category: 'size limits',
      filterLevel3Label: 'Level 3 filter',
      filterLevel3Category: 'other',
      specifiedBoardForceEnable: 'Ignore size/other filters, force enable',
      curveMaterialFilterTip: '(After checking "Irregular board", the board must first be irregular before material filtering applies)',
      cuttingSettings: 'Cutting settings',
      plankSizeLimitSuffix: ' boards',
      specifiedBoard: 'Specify board name cutting',
      specifiedBoardTip: 'After activation, if the board name includes the board name added below, it will take effect for secondary cutting',
      addPlankName: 'Add board name',
      plankNameEmpty: 'Board name cannot be empty, please enter',
      plankNameRequired: 'Please add at least one board name',
      plankLongLimit: 'The long side exceeds',
      plankShortLimit: 'The short side exceeds',
      cuttingSplit: 'Cut in two steps',
      longExpand: 'First cutting allowance: Long side allowance',
      firstExpand: 'First cutting allowance',
      longExpandTip: 'Long edge allowance',
      longLimit: 'Long edge exceeds',
      cuttingSplitTip: 'Condition for cutting long boards in two passes',
      shortExpand: 'Short side allowance',
      expandTip: 'Increase the long/short side dimensions by x mm each. For irregular long boards, the long side allowance applies to both sides.',
      pumpOffWay: 'Vacuum shutdown method',
      afterOnePlank: 'After cutting a single long board',
      afterAllPlank: 'After cutting the entire large board',
      numberFixed: 'Number of decimal places to keep',
      bufferCode: 'Buffer command for the surface of the board when starting the cut',
      layoutGap: 'Layout gap setting',
      layoutGapTip: 'Attention: Setting the layout gap to 0 may cause layout overlap',
      wasteCutting: 'Automatic waste truncation',
      zkPointCustomize: 'Z-Knuckle Slant Hole Machining Rotation Reference Point Customization',
      sawSetting: 'Saw Cutting Settings',
      cuttingLimit: 'Truncate size larger than',
      waste: 'of waste',
      wasteSizeLimit: 'The minimum size must not be less than 100mm',
      topLeft: 'Left and top sides',
      topLeftD: 'Top left corner',
      bottomLeft: 'Left and bottom sides',
      bottomLeftD: 'Bottom left corner',
      topRight: 'Right and top sides',
      topRightD: 'Top right corner',
      bottomRight: 'Right and bottom sides',
      bottomRightD: 'Bottom right corner',
      firstTime: 'First time',
      secondTime: 'Second time',
      thirdTime: 'Third time',
      startCutting: 'Cutting started',
      thickRange: 'Thickness ≥',
      longCut: 'Long board processing',
      edgeSetting: 'Edge trimming settings',
      cuttingOrder: 'Cutting order:',
      cuttingOrderTip: 'There is a risk of board running with this method, please use it carefully',
      plankFirst: 'Cut small boards first',
      wasteFirst: 'Cut waste material first',
      offTip: 'When turned off, it will follow the trimming settings in the cutting parameters',
      edgeCutDirection: 'Trimming Direction',
      lGapTip: 'The placement position of the gap in the L-shaped surplus material large plate is automatically adjusted in the diagonal direction of the positioning cylinder, except for the high gloss surplus material large plate, which is not compatible with the xy axis interchange function',
      cylinderDir: 'Positioning cylinder direction',
      onlyLong: 'Trim only long edges',
      backCutOrder: 'Back side trimming order',
      backFirst: 'Trim back side first',
      backSecond: 'Trim back side after hole and slot processing',
      frontReCut: 'Re-trim front side',
      frontReCutTip: 'To make the positioning cylinder edge smoother and prevent marks',
      useNewCut: 'Enable new trimming rules',
      newCutTip: 'Use this function when an additional trimming dimension is required on the front side of double-sided processing of large panels',
      fixedTip: 'Attention: Keeping the decimal places to 0 or 1 may cause overlapping in layout',
      cuttingSlow: 'Buffer on the surface of cutting parts',
      holeSlow: 'Buffer on the surface of punching parts',
      slotSlow: 'Buffer on the surface of grooving/milling holes/milling slots parts',
      slowCode: 'Usage of buffer commands',
      code: 'Command',
      bufferOffset: 'Buffer height offset of the surface of the part',
      zkRotatePoint: 'Rotation reference point',
      zkRotateDir: 'Rotation angle increment direction',
      restSizeLimit: 'Remaining size of surplus is less than',
      useSaw: 'Use saw blade',
      unGenSawPath: 'Do not generate longitudinal saw blade cutting path',
      suitMachine: 'Suitable for full aluminum welding plate processing',
      plankBack: 'Back of the large plank',
      plankLeft: 'Left side of the large plank',
      plankRight: 'Right side of the large plank',
      plankFront: 'Front of the large plank',
      frontSide: 'Front side',
      backSide: 'Back side',
      rightSide: 'Right side',
      leftSide: 'Left side',
      singleMachineLimit: 'Generate edge trimming path on the front of single-sided processed panels and perform edge trimming first',
      singleMachineLimitTip: 'This function does not apply to integrated machines or saw blade cutting',
      setBatchPositionWaring: 'Tip: If you need to cancel the quick modification of the cutting point mode, please uncheck the "Modify Cutting Point" button on the right side',
      setBatchPosition: 'Batch modify cutting points',
      setBatchPositionAs: 'Modify the cutting direction to:',
      activeBatchPosition: '{activePartCount}small board has been selected',
      specialFrontSide: 'Special slots set in the slot diversion are prioritized on the front side of the large panel',
      rollCountTip: 'Calculate the flip boards based on the actual processing by the engraving machine',
      specialFrontSideTip: 'The current production line does not support switching due to enabling the function of prioritizing special slots on the front side of the large board in slot diversion or calculating the flipping count based on the actual backside slot processing in the engraving machine after enabling slot diversion.',
      doubleTrim: 'Double sided panel trimming',
      trim: 'Trimming',
      trimTwoSide: 'Repair both sides',
      trimFourSide: 'Fix the four sides',
      rightInmShow: 'As shown in the figure on the right',
      currentTrimDir: 'for the currently selected trimming direction',
      cylinderTip: 'to locate the cylinder',
      onlyShort: 'Only repair the short edges',
      singleTrim: 'Single panel generation of trimming path',
      hierarchyCutTwice: 'Slot milling and slot cutting with layered indexing',
      knifeDia: 'Knife diameter less than or equal to',
      slotDeep: 'and the slot depth is greater than or equal to',
      cutTwiceSlot: 'When performing layered cutting of the slot',
      twiceSlotDeep: 'The cutting depth of the second layer is',
      cutTwiceCondition: 'Cutting conditions',
      zkPointCustomizeTip: 'Activating the XY axis swap will result in the processing direction and reference point being reversed',
      zkPointCustomizeTip1: 'This function does not work for devices that enable XY axis interchange',
      isCustom: 'Enable customization',
      useCutCon: 'Using sawing conditions',
      singleSetPlankSizeSpeed: 'Set Processing Speed for Specific Plank Size Range',
      singleSetPlankSizeSpeedTip: '(1. When the small plank meets the size settings below, it will be processed at the specified speed. 2. If the small plank meets multiple rules simultaneously, the rule with the earlier sequence number takes effect. 3. This feature does not apply to saw blade cutting.)',
      addSpeedRules: 'Add Rule',
      speedRules: 'Rule',
      shortSideSize: 'Short Side Size',
      lessThanEqual: 'Less Than or Equal',
      and: 'And',
      longSideSize: 'Long Side Size',
      processingSpeed: 'Processing Speed',
      trimLenCompensation: 'Trimming length compensation:',
      trimGenerateAPath: 'A trimming value of 0 does not generate a path:',
      cuttingMethod: 'Cutting method',
      horizontalCutting: 'Horizontal cutting',
      verticalCutting: 'Vertical cutting',
      openKnifeDistance: 'Slow distance'
      },
    labelingSettings: {
      title: 'Label Settings',
      output: 'Output Automatic Labeling File',
      specification: 'Label File Format',
      codeFrontGenerate: 'Automatically Generate Feeding Code Before Labeling Code',
      templateOffline: 'The Template Used Is Offline!',
      templateNotSupport: 'This template is not supported, please select again!',
      rollLabelling: 'Flip Labeling Settings',
      flipSetting: {
        title: 'Flip Settings',
        engravingFlipProcess: 'Enable Engraving Machine Flip Processing Labeling Mode',
        flipTip: 'Enable this function when the engraving machine needs to flip for processing'
        },
      rotateSetting: {
        title: 'Label Rotation Settings',
        rotateTip: 'When the board size is smaller than the set value for the width or height, the label will rotate 90° clockwise',
        horizontal: 'Board Width',
        vertical: 'Board Height',
        either: 'Board Width OR Height'
        },
      countertopSetting: {
        title: 'Workbench Settings',
        startPoint: 'Workstation Starting Point:',
        upLeft: 'Upper Left',
        upRight: 'Upper Right',
        downLeft: 'Lower Left',
        downRight: 'Lower Right',
        baseExchange: 'Coordinate Base Exchange:',
        exchangeX: 'X-axis Exchange',
        exchangeY: 'Y-axis Exchange'
        },
      offset: 'Label Coordinate Offset',
      offsetTip: 'Generally, the labeling coordinate is at the center of the small board, but some devices require adjustment',
      label_rotate_offset: 'Label Offset After Rotation',
      label_rotate_offset_tip: 'Adjust when the offset position differs significantly before and after label rotation',
      label_rotate_offset_err_tip: 'After the label rotation coordinate offset is turned on, the X and Y axis coordinate offsets are required',
      imgSetting: {
        title: 'Label Image Settings',
        suffix: 'Label Image Suffix:',
        code: 'Image Coding Method:',
        codeTip: 'Png, jpeg will synchronously modify the coding format of the layout image, and the embedded cloud layout does not support this feature',
        imgRatio: 'Label Image Resolution:',
        slowDown: 'Will reduce the efficiency of exporting label images',
        color: 'True Color',
        bit: 'Black and White',
        resolution: 'Label Image Resolution',
        resolutionPlaceholder: 'Resolution',
        labelPool: 'Data Label Pool',
        showKey: 'Display Fields',
        dragTip: 'You can drag and drop labels within the label pool',
        labelImgName: 'Label Image Name',
        labelImgNameErrTip: 'The label image name cannot be empty',
        labelTip1: 'When customizing, either [Board Barcode] or [Label Sequence Number] must be used, otherwise there may be image overlay issues',
        labelTip3: '【Label Sequence Number】 is the serial number of the small board from top to bottom in the cutting list, and the small board added on the layout page has no this data',
        labelTip2: '3. This feature does not apply to the labeling machine system template',
        delimiter: 'Delimiter:',
        inputTip: 'Does not support input of characters such as / : ? < > | . ” *',
        numStart: 'Starting Value for Label Sequence Number',
        example: 'Custom Label Image Name (Example)',
        stockNumOffset: 'The compensation digit of the large board serial number arrives.',
        divideFolders: 'Divide label images into different folders based on large boards',
        foldersTip1: "Attention: 1. This feature cannot be used together with the 'Merge with Material Cutting Machine Files' feature",
        foldersTip2: '2. This feature is not yet effective for the embedded cloud layout',
        stickIntoFolders: "Insert labeling files into the corresponding large board's label image folders:",
        stickTip1: "Attention: 1. This feature needs to be used in conjunction with the 'Export Labels Along with Downloading NC' feature;",
        stickTip2: "2. This feature will only take effect if the file generation rule in the used labeling template selects 'Generate Single File';",
        stickTip3: '3. This feature is not yet effective for the embedded cloud layout'
        },
      pdfSetting: {
        title: 'Label PDF Settings',
        pdfLabelName: 'PDF File Name',
        example: 'Custom PDF File Name (Example)',
        address: 'Project Address',
        orderNo: 'Order No.',
        firstFolder: 'First-level Folder',
        customerName: 'Customer Name'
        },
      paibanImgSetting: {
        title: 'Layout Image Settings',
        tip: 'The export of custom layout diagrams has been enabled. The fixed template below cannot be exported. If you need to export, please turn off exporting custom layout diagrams in the more settings section of the layout page',
        reparation: 'Automatic Compensation of Layout Image Sequence to',
        figure: 'Position',
        inputTip: 'Please enter a number between 1-99',
        paibanImg: {
          export: 'Export Layout Image',
          prefix: 'Layout Image Name Prefix',
          size: 'Layout Image Size',
          format: 'Layout Image Format',
          directional: 'Layout Direction',
          vertical: 'Vertical',
          horizontal: 'Horizontal'
          }
        },
      autolabel: 'Automatic Labeling Order Setting',
      customTemp: 'Effective Only for Custom Templates',
      cuttingLabelOder: 'Labeling According to Cutting Order',
      labelToUp: 'Labeling from Bottom to Top Based on Layout',
      labelToDown: 'Labeling from Top to Bottom Based on Layout',
      labelDodge: 'Automatic Label Avoidance',
      nolabelForsurplus: 'No labeling file is generated for the remaining material plate',
      settingValue: 'Select Setting Value',
      enabelTip: 'When enabled, the label will rotate if the small board meets the following setting values',
      fixedHori: 'Select Parallel to the Fixed Edge of the Small Board',
      fixedHoriTip: 'Effective Only for Non-textured Small Boards. When enabled, the label will rotate to align the horizontal edge of the label with the fixed edge of the small board during labeling',
      tagHori: 'Label Horizontal Edge',
      effectiveTarget: 'Target of Effectiveness',
      allPlank: 'All Planks',
      notcarePlank: 'Texture-Free Planks Only'
      },
    drillSettings: {
      title: 'Drilling Machine Settings',
      enable: 'Enable Drilling Package',
      toolTable: {
        use: 'Enable',
        number2: 'Station 2 Drill Number',
        number: 'Drilling Machine Number',
        diameter: 'Drill Bit Diameter',
        xOffset: 'X Offset',
        yOffset: 'Y Offset',
        moveZF: 'Z-Axis Rapid Move Speed',
        feedRate: 'Z-Axis Machining Speed',
        moveF: 'XY-Axis Rapid Move Speed',
        benchmarkDrill: 'Benchmark Drill',
        addKnife: 'Add Tool',
        deleteKnife: 'Delete Tool'
        },
      prefix: 'Drilling Machine Prefix',
      suffix: 'Drilling Machine Suffix',
      startCode: 'Drilling Machine Start Code',
      endCode: 'Drilling Machine End Code',
      combineKnife: 'Combined Drilling Machine Cuts',
      combineTable: {
        prefix: 'Drilling Machine Number Prefix',
        suffix: 'Drilling Machine Number Suffix',
        mainHole: 'Main Hole',
        extraHole: 'Extra Hole',
        notes: 'Combined Notes',
        firstUseNotes: 'First Use Notes',
        addExtraHole: 'Add Extra Hole',
        deleteExtraHole: 'Delete Extra Hole',
        example: 'Example'
        },
      tagPool: {
        drillRowNumber: 'Drill row number'
        },
      processSetting: {
        title: 'Processing Settings',
        mode: 'Drilling Machine Processing Mode',
        processTip: 'This feature will not be effective when selecting this mode',
        recentHole: 'Drill Nearby Holes (Rapid Tool Change)',
        groupHole: 'Drill by Category (Change Tool After Completing a Category)',
        drill_benchmark: 'Combination of tool setting benchmarks',
        drill_benchmark_Tip: '（Attention：After selecting this method, the drill combination tool setting function will not take effect）',
        mainHole: 'Main hole',
        secondaryHole: 'Secondary hole (Tail hole)'
        },
      changeBenchDrillTip: 'Please enter the drilling machine number before making this selection'
      },
    NCExportSettings: {
      jumpSkipTip2: 'Classify into different folders by large board color, thickness, and material (including labeling files), and place cutting material files of the same size large board in the same folder',
      title: 'NC Export Settings',
      tab1: 'Nesting Machine File Name Settings',
      tab2: 'Nesting Machine File Name Merging',
      tab3: 'Nesting Machine File Comments',
      tab4: 'Nesting Machine File Types',
      tab5: 'Nesting Machine File Folders',
      tab6: 'Processing Instruction Settings',
      tab7: 'File Format Settings',
      fileNameSettings: {
        twoStationAutoSort: 'Automatic Sorting for Dual Stations',
        reparation: 'Compensate the Number of Digits for Panel Serial Numbers to',
        figure: 'Position',
        labelerBegin: 'Label Machine Prefix',
        machineCenter: 'Machining Center Prefix',
        front: 'Front Side:',
        back: 'Back Side:',
        customizeName: 'Custom File Name (Format):',
        example: 'Custom File Name (Example):',
        emptyTip: 'Both front and back file identifiers cannot be empty at the same time',
        labelPool: 'Data Label Pool',
        dragTip: 'You can drag or click to copy the tags in the tag pool to the input box'
        },
      fileMerge: {
        engravingMerge: 'Nesting Machine File Merging',
        zfMerge: 'Front and Back Side Merging',
        singleMerge: 'Single Station Merging',
        doubleMerge: 'Dual Station Merging',
        fEndCode: 'Back Side End Code',
        zBeginCode: 'Front Side Start Code',
        displayfbInfo: 'Display Front and Back Side Information in File Name',
        fBeginCode: 'Back Side Start Code',
        zEndCode: 'Front Side End Code'
        },
      marginalNotes: {
        addPlankInfo: 'Add Current Panel Information to the Beginning of Nesting Files:',
        plankInfo: 'Panel Information:',
        addStationCodeFirst: 'Add Station Code to the Beginning of Nesting Files:',
        addStationCodeSecond: 'Add Station Code Before Tool Change in Nesting Files:'
        },
      fileType: {
        zAddtion: 'Z-Axis Addition:',
        addSemicolon: 'Add Semicolon at the End of Each NC Line:',
        semicolonTip: 'Checking this box will also affect the processing files for horn handles',
        fileName: 'File Name',
        defaultName: 'Default File Name',
        dedicatedName: 'Dedicated File Name for Xinghui Equipment',
        xhNotes: 'Xinghui E2-9 Notes',
        format: 'Output Engraving Machine File Format',
        example: 'File Example: NC File',
        stillGenerate: 'Generate the back NC file containing the back end code even when the back side is not processed',
        generateTip: 'This feature is not supported when used together with the file merging feature',
        fileNameErrTip: 'File names cannot contain any of the following characters: / : * ? "'
        },
      categorize: 'Categorize into different folders based on panel color, material, and thickness (including labeling files):',
      simplifyG: 'Simplify G-Code Instructions',
      ZToW: 'Change Code from Z-Axis to W-Axis',
      knives: 'Drilling Tools',
      lineBreakSetting: 'Line Break Format Settings',
      codeFormatSetting: 'File Encoding Format Settings',
      utf8bom: 'UTF-8 with BOM',
      oneCodeSetting: 'Panel Barcode Settings',
      simplifyOneCode: 'Generate Simplified Format Label Barcode',
      codeLocation: 'Code Location Settings',
      generateLocation: 'Generate station end code before the back side end code',
      emergencySetting: 'Emergency Settings',
      show: 'Show Emergency Settings',
      emergencyCode: 'Emergency Code',
      params: 'Parameters',
      emergencyTip: 'Can temporarily implement some niche features with the cooperation of after-sales personnel',
      holeSetting: 'Hole punching file settings',
      holeFileCategorize: 'Hole punching files are placed separately in folders according to different orders',
      holeTip: 'Does not take effect on the cloud typesetting of the embedded cabinet client',
      specialCodeErr: 'Special characters are not supported!',
      copySuccess: 'Copy successful!',
      copyErr: 'Copy failed, please try dragging the tag!',
      lengthLimit: 'Only supports input of 15 characters!',
      plankInfo: 'Board information',
      otherInfo: 'Other information',
      uniqueBarCode: 'Unique barcode for the plate',
      uniqueBarCodeForPack: 'Unique barcode for the plata(Only for packaging)',
      machineOrder: 'Generate processing sequence number from cutting file name',
      folderSetting: 'Place cutting files of the same size boards in the same folder',
      labelImageINCFolder: 'Place the labeled images and accompanying label files in the NC folder',
      custom: 'Cutsom',
      folderSettingTip: 'Attention: Embedded layout does not support this feature yet',
      settingMoveTip: 'The original "{func}" function has been moved to the "{module}" page!',
      fileManagerFunction: 'Place drilling files in separate folders according to different orders',
      gotoSetting: 'Go to settings',
      singleFileTitle: 'Single File Processing Settings',
      slectSingleProcess: 'Select single output process',
      slectSingleProcessTip: 'Paid secondary processing processes still exist. Please remove them and save again',
      setSingleRegularSize: 'Set regular hole and slot size for single output',
      holeRange: 'Hole effective range',
      slotRange: 'Slot effective range',
      holeRangeTip: 'Hole effective range cannot be empty, please fill in!',
      slotRangeTip: 'Slot effective range cannot be empty, please fill in!',
      yhzc: 'Straight slot on arc-bent section',
      xbgy: 'Beveled Haitang corner and beveled handle',
      nbyx: 'Internal irregular shape',
      secondaryProcessingMerge: 'Secondary processing file merge',
      secondaryProcessingMergeName: 'Merged file name',
      secondaryProcessingMergeTip: 'When enabled, if the exported panel has multiple secondary processes, they will be merged into one processing file',
      singleFileSetting: 'Output single file processing with beveled edges, cherry blossom corners, and slanted handles',
      straightArcSlot: 'Output single file processing with straight slots in arc-bent parts'
      },
    aioMachineSetting: {
      openFunction: 'The following functions need to be enabled for docking',
      openCarving: 'Enable the carving machine',
      xyReverseFunction: 'XY Axis Swap Function',
      carvingStartSet: 'Set the carving machine start position to',
      rightTop: 'Top Right',
      carvingEdgeSet: 'Adjust the front edge trimming value of the carving machine to',
      finalEdgeSame: 'Same as the final trimming value',
      beginCode: 'Program Start Code',
      endCode: 'Program End Code',
      drillHole: 'Drill Hole',
      pullTrough: 'Pull Trough',
      showDataTemp: 'Show Data Sample',
      dataTemp: 'Data Sample',
      title: 'All-in-one machine settings',
      outputFile: 'Output processing file for all-in-one machine',
      outputFileTips: 'After enabling the all-in-one machine, it is not compatible with XY interchangeable file merging without penetrating the irregular holes. Please use it with caution',
      fileType: 'File format',
      select: 'Please select',
      diameter: 'diameter of the trimming tool',
      jidongTip: 'When using the East-Japan integrated machine, please set the starting point of the engraving machine station to the upper right corner and activate ',
      skill: 'Function',
      clampHandLength: 'Gripper length(L)',
      clampHandWidth: 'Gripper width（W）',
      clampHandMargin1: 'Clamp hand 1 margin(H1)',
      clampHandMargin2: 'Clamp hand 2 margin(H2)',
      duchClampHand: 'The hole groove avoids the clamping hand position',
      clampHandDirection: 'Hand direction',
      left: 'left',
      right: 'right',
      top: 'top',
      bottom: 'bottom'
      },
    oneDragTwo: {
      title: 'One to two engraving machine',
      outputMachineFile: 'Output the processing file for the one-to-two engraving machine',
      outputMachineFileTips: 'After enabling the "one-to-two" engraving machine, it is not compatible with the file merging function of the cutting machine. Please use it with caution',
      fileType: 'File format',
      select: 'Please select',
      machineStart: 'starting point of the workstation',
      positionClose: 'When closing, it will follow the starting point setting of the workstation in the cutting parameters',
      engravingPlus: 'Rapid engraving machine'
      },
    sawEngraving: {
      title: 'Saw and engraving machine',
      preLayNav: 'Saw and engraving machine settings',
      preLayKnifeInput: 'Cross cutting blade diameter of saw blade',
      enableSaw: 'Enable sawing and engraving machine',
      sawAioTip: 'You do not have permission to output welding plate AIO data. Please contact sales to enable this feature.',
      cutSet: 'Welding Plate Cutting Settings',
      weldingPlank: 'Welding plate',
      doorFrame: 'Door frame',
      doorFrameTip1: 'The radius of the cutting blade must be less than or equal to the thickness of the saw blade',
      doorFrameTip2: '2.Unsupported irregular plate layout 3.Automatic spacing for layout',
      sawUsing: 'Usage of saw blade',
      trim: 'Trimming',
      cutBlank: 'Cutting and blanking',
      backTrimOblique: 'Back trimming',
      holeSlotOblique: 'Hole slot',
      plankThicknessUnit: 'Plank thickness unit',
      sawUseCond: 'Saw blade usage conditions',
      exportPartData: 'Output small board data file',
      sawAioTip2: 'Applicable to non-flipping data cutting all-in-one machine',
      hasUsing: 'Use available path',
      onlyUse: 'use only when necessary',
      cutMethod: 'Cutting method',
      oneKnifePull: 'Cut through the large board with one stroke',
      onlyOneKnifePull: 'only then did he directly pull it through with one knife',
      enableSawThick: 'Enable saw blade thickness layout',
      edgedDir: 'The edge of the large board that has been sealed and will not be cut again',
      sameWidthPart: 'Only small boards of the same width are placed on each large board',
      emptyPath: 'No empty path is generated when the small plate is cut',
      sawUsePlank: 'Cutting welded plates with a saw blade',
      paibanGap: 'Layout gap for welded plates',
      minSurplusWidthDiff: 'Minimum Scrap Matching Width Difference',
      minSurplusWidthDiffTip: 'Only when the width difference between the small board and the remaining material is less than this value, will the small board be placed on the remaining material',
      sawReplaceEnable: 'Cutting path of straight saw replaced with saw blade',
      minSawLength: 'Minimum distance to replace with saw blade',
      keepDistance: 'Keep distance between adjacent wider boards for cutting path of straight saw',
      keepDistanceTip: 'Note: Leave enough space to avoid cutting into adjacent boards',
      sortByLength: 'Sort by plank length',
      sortByLengthTip: 'The cutting direction is from bottom to top in sequence. The plates are arranged first by width and then by length',
      plankAtTop: 'Small board at the top',
      plankAtBottom: 'Small board at the bottom',
      useSawTipOne: 'After activation, only the small plates with welded plate attributes in the cabinet will be processed with saw blades, while non-welded plates will be cut with straight knives',
      useSawTipTwo: 'After enabling "Custom Large Board Layout Sequence", standard large boards will not be used for layout. If mixed layout is required, please add the original data of welded boards and honeycomb boards in the special large boards',
      useSaiTipThree: 'After enabling this function, the nesting solution must use the sawing layout',
      surplusStoreAndLabeling: 'Cut off the remaining material can be stored and printed labels',
      surplusMinLength: 'Minimum usable length of remaining material',
      surplusMinSize: 'Minimum usable size of remaining material',
      crossCutOnlyMinSurplusSize: 'Surplus will generate a cross-cutting path only if the minimum usable size is met',
      surplusStoreAndLabelingTip: '1、The blue surplus area will be generated on the top or bottom of the large board, which can be normally stored and printed labels',
      surplusStoreAndLabelingTip2: '2、The "automatic cutting of remaining materials" function will not take effect for welded plates）',
      surplusStoreAndLabelingTip3: '（After activation',
      backCutSurplus: 'Cut off the remaining material from the reverse side',
      cutSurplusTip: 'After enabling, please set the reverse-side trimming order to "Trim after reverse-side slot machining"',
      top: 'Top',
      bottom: 'Bottom',
      left: 'Left',
      right: 'Right',
      dockTip: 'The processing of butt welded plates requires the sealing of the edges on all four sides of the rectangular plate, similar to the overall trimming, and manual operation in a single row layout',
      sawToLayoutTip: 'Saw cutting layout does not currently support specifying the cutting tool',
      sawToLayoutTip2: 'The sawing layout function does not currently support specifying a blanking cutter.',
      tempPaiabanTip: 'After enabling saw blade cutting, it is not supported to directly add irregular plates in the layout. If you need to add them, please go to the cutting list to add and layout them!',
      generateCutSurplusPath: 'Generate a crosscut path that cuts off the remaining material first',
      curSurplusPathTip: 'After activation, set the reverse trimming order as "trim after reverse hole/slot machining"'
      },
    robotArmDocking: {
      autoLine: 'Automatic line docking',
      autoLineTip: 'You do not have permission to use automatic lines or the number of automatic lines you can open is not enough',
      title: 'Robot arm docking',
      enable: 'Enable robotic arm docking',
      enableTip: 'After activation, when outputting production files, the docking file of the robotic arm will be output'
      },
    laserCuttingMachine: {
      title: 'Laser cutting all-in-one machine',
      enable: 'Enable laser cutting all-in-one machine',
      backSafeHeight: 'Z height when back side is idle (H)',
      laserDistance: 'Distance between laser knife and board surface when cutting on front/back',
      coordinateAxis: 'Coordinate axis',
      xAxis: 'X',
      yAxis: 'Y',
      zAxis: 'Z',
      cuttingSettings: 'Cutting settings',
      backKnifeStore: 'Back knife store',
      noSupportOriginalMaterialKnife: 'The "Original material cutting knife selection" function is not currently supported',
      laserKnifeTip: 'Cutting open: Used for processing internal shapes that have not been pierced',
      laserKnifeTip2: 'Laser knife: Processing pierced holes/slots, internal shapes, outer contour cutting',
      laserKnifeTip3: 'Attention: The back Z-axis uses relative coordinates corresponding to the distance from the table surface by default',
      laserKnifeTip4: 'The number of knives cannot be less than 1',
      laserKnifeTip5: 'Cannot delete the cutting open knife',
      laserKnifeTip6: 'No knife selected for cutting open detected, please select at least one knife',
      laserKnifeTip7: 'Laser knife cannot process internal shapes that have not been cut through, the "Cutting open" option has been automatically unchecked',
      laserKnifeTip8: 'Please select knives with the "Cutting open" option in the knife store, otherwise internal shapes that have not been cut through cannot be processed',
      laserKnifeTip9: 'The laser knife diameter in the cutting open knife store is inconsistent with the laser knife diameter of the integrated laser machine, please check',
      laserKnifeTip10: 'The cutting open knife diameter in the cutting open knife store is inconsistent with the cutting open knife diameter of the integrated laser machine, please check',
      laserKnifeTip11: 'Equipment docking parameters have been modified, please re-layout',
      noLaserPermission: 'You do not have permission to use the integrated laser machine. Please contact sales to purchase the integrated laser machine usage permission before using',
      laserOpenCode: 'Laser Open Code',
      laserCloseCode: 'Laser Close Code',
      laserToolSettings: 'Laser Tool Settings'
      },
    firstSave: 'It is detected that the user is using cloud typesetting for the first time. After saving the settings, please pay attention to whether the trimming direction in the file is reasonable to avoid unnecessary losses',
    knives: {
      xOffset1: 'X Coordinate Offset',
      yOffset1: 'Y Coordinate Offset',
      zOffset1: 'Z Coordinate Offset',
      insert: 'Insert a row',
      delete: 'Delete the row',
      tip: '（Note: After modifying the tool library information or adjusting settings, users producing cabinet layouts need to restart the cabinet client to apply the latest changes!）',
      number: 'number',
      name: 'Name',
      diameter: 'Blade DiameterΦ',
      sawDiameter: 'Saw Blade ThicknessΦ',
      cutting: 'Cutting Material',
      use: 'Purpose',
      moveZF: 'Z-axis fast movement speed',
      axis_offset: 'Axis Offset Setting',
      arc_radius: 'Arc Radius Setting',
      cutZF: 'Z-axis processing speed',
      moveF: 'XY axis fast movement speed',
      cutF: 'XY axis processing speed',
      startCode: 'Start code for tool change',
      stopCode: 'Tool change end code',
      startCode2: 'Code for starting tool change',
      stopCode2: 'Tool change end code',
      knifeLength: 'Knife length',
      maximum_single_depth: 'Maximum depth of machining in a single run',
      specialShapeKnifeTip: 'Only for internal irregular shapes',
      preStartCode: 'pre-start code',
      punchHoles: 'Punch Holes',
      pullSlots: 'Pull Slot',
      millHoles: 'Milling Holes',
      millSlots: 'Milling slot',
      sawBlade: 'saw blade',
      doubleSaw: 'Enable double-bit different tool change start code',
      singleStation: 'Single-station',
      doubleStation: 'Two-station',
      sawBladeTip: 'This function does not work for 1-to-2 engraving machines and all-in-one machines',
      serialNum: 'serial number',
      sawWidth: 'Knife width',
      sawType: 'Saw blade type',
      cutDirection: 'Cutting Direction',
      moveSpeed: 'empty speed',
      cutSpeed: 'processing speed',
      endCode: 'End code for tool change',
      sawDownCode: 'Lowering code',
      sawUpCode: 'Tool-off code',
      abscissa: 'prefix of the abscissa',
      ordinate: 'The prefix of the vertical coordinate',
      sawHor: 'cross-cutting saw blade',
      sawVer: 'vertical cutting blade',
      towardsZero: 'Cut towards the 0 point coordinate',
      awayFromZero: 'Cut away from the 0 coordinate',
      diameterDesc: 'diameter of the knife Φ',
      xOffset: 'Horizontal coordinate offset',
      yOffset: 'Vertical coordinate offset',
      zOffset: 'offset of the elevation coordinate',
      offsetX: 'Offset X',
      offsetY: 'Offset Y',
      offsetZ: 'Offset Z',
      offsetNo: 'Offset number',
      knifeWidth: 'knife width',
      drill: 'cut',
      cut: 'processing',
      speed: 'Speed',
      type: 'Type',
      millHoleSlot: 'Milling hole/slot',
      rapidFeedSpeed: 'Rapid feed speed',
      typeOption1: 'Bit',
      typeOption2: 'Milling cutter',
      typeOption3: 'Styling knife',
      typeTip: 'After setting the tool type, the hole slot will match the corresponding type of tool for machining'
      },
    other: {
      title: 'Others',
      tip: 'For single-station equipment, both Station 1 and Station 2 must be assigned the same automatic feeding code'
      }
    },
  sideHoleMachine: {
    moreSetting: 'More Settings',
    sideStartCode: 'Front processing generates face change code',
    useArcCode: 'Arc interpolation command for cutting arcs',
    coordSwitch: 'Coordinate Reference Switch',
    updownCoordSwitch: 'Lifting Coordinate Reference Switch',
    xCoordSwitch: 'Swap the benchmarks of the horizontal coordinates',
    yCoordSwitch: 'Swap the benchmarks of the vertical coordinates',
    knifes: {
      number: 'Number',
      diameter: 'Blade Width',
      type: 'Type',
      moveSpeed: 'Rapid Feed Speed',
      doSpeed: 'Processing Speed',
      startCode: 'Tool Change Start Code',
      endCode: 'Tool Change End Code'
      },
    ymSetting: 'Yimu Connection Settings',
    flanking: 'side processing',
    frontProcess: 'front processing',
    oldSetting: 'Old version setting',
    equipParamsSetting: 'Equipment parameter setting',
    holeSetting: 'Hole setting',
    raminoSetting: 'Ramino connection setting',
    mortiseTenonSetting: 'Tenon and mortise connection setting',
    straight: 'Straight Type',
    eccentric: 'eccentric Type',
    pbSize: 'Upper and lower breaking board size',
    slotOverlapRate: 'Overlap ratio of milling groove',
    breakingBoardDirection: 'Direction of upper and lower plate breaking',
    coordinateValue: 'coordinate value',
    codeFormat: 'File encoding format',
    suffixSetting: 'File suffix setting',
    insertRow: 'Insert Row',
    deleteRow: 'Delete Row',
    equipmentParams: {
      equipPauseCode: 'Equipment Pause Code',
      wiggleCode: 'Wiggle Code',
      equipStartCode: 'Equipment start code:',
      flipPauseCode: 'Pause code for flipping',
      equipEndCode: 'Equipment end code:',
      equipStartCodePlaceholder: 'Enter the device start code',
      retractingCode: 'Tool retraction command code',
      retractingCodePlaceholder: 'Enter the tool retraction command code',
      flipPauseCodePlaceholder: 'Enter the flip pause code',
      equipEndCodeTip: 'Enter the equipment end code',
      sideChangeSetting: 'Side change setting',
      workTip: 'By default, processing starts from the left side ① and proceeds in a counter-clockwise direction',
      frontTurnCode: 'Start code above:',
      frontTurnEndCode: 'End code above',
      frontTurnCodePlaceholder: 'Enter the start code above',
      frontTurnEndCodePlaceholder: 'Enter the end code above',
      leftTurnCode: 'Left start code:',
      leftTurnEndCode: 'Left end code:',
      leftTurnCodePlaceholder: 'Enter the left start code',
      leftTurnEndCodePlaceholder: 'Enter the left end code',
      downTurnCode: 'The following is the code:',
      downTurnEndCode: 'End code below:',
      downTurnCodePlaceholder: 'Enter the following start code',
      downTurnEndCodePlaceholder: 'Enter the following end code',
      rightTurnCode: 'Right-hand start code:',
      rightTurnEndCode: 'Right end code:',
      rightTurnCodePlaceholder: 'Enter the right start code',
      rightTurnEndCodePlaceholder: 'Enter the right end code',
      topFlipCode: 'Flip Code - Top',
      downFlipCode: 'Flip Code - Down',
      leftFlipCode: 'Flip Code - Left',
      rightFlipCode: 'Flip Code - Right',
      cylinderOutCode: 'cylinder out code',
      cylinderbackCode: 'Cylinder retract code',
      cylinderbackDirective: 'Cylinder retract command',
      moveDirective: 'Move Instruction',
      moveAxisCode: 'Move Axis',
      pushAxisCode: 'Cylinder push axis',
      swingAxisCode: 'swing axis',
      moveCode: 'Move Code',
      punchCode: 'Processing Code',
      free: 'free walk',
      punchPart: 'Processing part',
      cutFaceCode: 'Processing plane code',
      horVerCutFace: 'Horizontal and vertical plane',
      horCutFace: 'Horizontal lifting plane',
      verCutFace: 'Vertical lifting plane',
      specifySmallBoardMaterialNoCut: 'Specify small board material no cutting',
      specifySmallBoardMaterialNoCutTip: 'Planks containing corresponding keywords in the material will only generate hole and slot files processed by 5/6-sided drill, no cutting',
      addMaterialKeyword: 'Add material keyword',
      keyword: 'Keyword'
      },
    tagPool: 'Data tag pool',
    dragTip: 'Drag the label in the label pool',
    knives: 'Processing tools:',
    directives: 'Processing instructions:',
    slot: 'Straight slot processing',
    cirWork: 'arc machining',
    cirInter: 'circular interpolation',
    cirOption1: 'Clockwise: G03 Counterclockwise: G02',
    cirOption2: 'Clockwise: G02 Counterclockwise: G03',
    coordinate: {
      xPointSymbol: 'X-coordinate:',
      yPointSymbol: 'Y-coordinate:',
      zPointSymbol: 'Z-coordinate:',
      upright: 'Positive value',
      negative: 'Negative value'
      },
    encodeFormat: {
      format: 'File encoding format:',
      wrap: 'Line wrap format setting:',
      formatOption1: 'UTF-8 format',
      formatOption2: 'ANSI format'
      },
    suffix: 'File suffix setting:',
    enableFP: 'Enable front processing',
    slotSetting: 'Slot setting',
    slotMillSetting: 'Groove pulling / milling / drilling setup',
    millSlot: 'Supports milling holes and grooves',
    millingSlotOverlapRate: 'Milling groove overlap rate',
    millingHoleSlotOverlapRate: 'Milling hole and groove overlap rate',
    takeUpDirective: 'Knife retraction command',
    workSeparately: 'Process the through slot on the front and back separately',
    secondSlotLong: 'Length of the second slot',
    enableOld: 'Enable the old version of the side hole machine setting',
    default: 'Default setting',
    customizable1: 'Custom 1',
    customizable2: 'Custom 2',
    customizable3: 'Custom 3',
    customizable4: 'Custom 4',
    knifeSetting: 'Knife setting',
    soltTip: '(Including milling holes/slots)',
    specialSetting: 'Special setting',
    ramino: 'Ramino',
    sun: 'Mortise and tenon',
    please: 'Stay tuned',
    designatedKnives: 'Designated knives',
    designated: 'Designated',
    workOrder: 'Processing command',
    other: 'Others',
    nameSetting: 'Suffix name setting',
    repeatErr: 'The number is duplicate. Please reset it.'
    },
  electronicSaw: {
    importMaterial: 'Import Material List',
    formSetting: 'Electronic Saw Form Setting',
    fileFormat: 'Output File Format for Cutting List:',
    isSmallFile: 'Export Small Board Image File:',
    fileGroupRule: 'Divide Electronic Saw Files into Different Tables Based Color on, Material, and Thickness:',
    roomsByCategory: 'Divide Electronic Saw files into Different Tables Based on Rooms:',
    delimiter: 'Delimiter:',
    fileName: 'Cutting List File NameEncoding:',
    fineNameTip: 'Open list file name cannot be empty!',
    fileNamePlaceholder: 'Custom Cutting List',
    outputFileEncoding: 'Output list encoding format:',
    utf8: 'UTF-8 with BOM',
    cellTab: 'Generate Cell Tabulators:',
    texture: 'Texture Representation:',
    special: 'Special Shape Representation:',
    notSpecial: 'Not a Special Shape',
    genSimpleLabelBarcode: 'Generate Simple Format Label Barcode',
    uniqueBarCode: 'Unique barcode for the plate',
    uniqueBarCodeTip: 'Generate simple format label barcode function does not work after enabled',
    roboticArmDocking: 'Robotic Arm Docking',
    customeForm: 'Custom Form',
    tagPool: 'Data Tag Pool',
    tagPoolTips: 'Drag and Drop or Click to Copy Tags from the Tag Pool',
    displayHead: 'Hide Table Header',
    addTableHead: 'Add Table Header',
    deleteTableHead: 'Delete Table Header',
    generateExample: 'Generate Output Form Example',
    importExample: 'Import Form Example',
    importExampleTip: 'The imported form example is only for reference when customizing the electronic saw',
    importExampleErrTip: 'No material list has been imported, please import the material list first',
    outputExample: 'Output Form Example',
    outputExampleTip: 'Output example of the custom form',
    outputExampleErrTip: 'No output form example has been generated, please generate one first',
    defaultTableHead: 'Default Table Header',
    deleteHeadErrTip: 'No table header to delete!',
    genNonString: 'Generate non-text data type',
    genNonStringTip: 'Try enabling this when the generated table data cannot be recognized by the electronic saw',
    revertWidth: 'Horizontal panel length and width adjustment'
    },
  lockModal: {
    passwordInput: 'Please enter the password',
    lockPassword: 'Unlock Password',
    lockPasswordInput: 'Please enter the unlock password',
    passwordInputPlaceholder: 'Please enter a four-digit password',
    editPassword: 'Change password',
    confirmPassword: 'Confirm password',
    setLockPwd: 'Set Unlock Password',
    pwdFormatErr: 'Incorrect password format',
    sendMessageTo: 'SMS verification code will be sent to',
    captchaPlaceholder: 'Please enter the verification code',
    sendCaptcha: 'Send Verification Code',
    sendSeccess: 'SMS sent successfully',
    sendFail: 'SMS failed to send, please try again later',
    updateSeccess: 'Password set successfully',
    editSuccess: 'Password changed successfully',
    lockSeccess: 'Unlock successful',
    lock: 'Unlock',
    lockSeccessTip: 'Lock successful',
    inputErrLimit: 'The current number of errors has reached the limit, please reset the unlock password!'
    },
  dock56Drill: {
    equipType: 'Equipment Type',
    equipment: 'Equipment',
    fiveDock: 'Five-Sided Drill',
    sixDock: 'Six-Sided Drill',
    fileType: 'Generated File Type',
    templateOffline: 'The template used has been discontinued!',
    showExample: 'Show Data Example',
    conNoticeTip: 'Connection Notes:',
    conNoticeTip1: '1. Engraving machines with "XY Axis Swap" enabled need to enable the "Hole and Slot Processing Device Automatic Adaptation Swap" function in the engraving machine.',
    conNoticeTip2: '2. To display or process special parts of the board on the five/six-sided drill, special part data needs to be configured in the template.',
    conNoticeTip3: '3. After first using the five/six-sided drill or changing the template, please conduct a test production of the cabinet and confirm its correctness before regular production.',
    conNoticeTip4: '4. During test production, carefully inspect the size, depth, location, and face of the holes and slots on the front and back. Avoid issues with cabinet mirroring.',
    example: 'Data Example',
    commonSetting: 'Common Parameter Settings',
    throughHoleSetting: 'Through-Hole Drilling on Both Sides',
    throughSlotSetting: 'Through-Slot Drilling on Both Sides',
    nonHolesNotFiles: 'No hole or slot data, no file output for rectangular boards:',
    frontFileIdentifier: 'Front File Identifier:',
    oppositeFileIdentifier: 'Opposite File Identifier:',
    oppositeFileIdentifierTips: 'Generated as: Original 13-digit part code + identifier character',
    arcDescription: 'Arc Description Method',
    linePoints: 'Line Segment Formation Description',
    arcCommand: 'Arc Command Description',
    slotWidthSplit: 'Split wide slots into multiple narrow slots for processing:',
    slotSplitWidth: 'Width of single slot after splitting:',
    mm: 'Attention: The splitting target is for regular rectangular slots',
    isNotMergeSlot: 'Merge adjacent slots with the same width and depth:',
    slotPunchTip: 'This function only applies to backboard slots and drawer bottom slots using custom templates',
    sizeRange: 'Adjacent sizes less than or equal to',
    enableWorningTip: 'This function cannot be enabled simultaneously with the front edge placement direction',
    longDirection: 'Board Length Placement Direction',
    horizontal: 'Horizontal',
    vertical: 'Vertical',
    slotDirection: 'Five/Six-Sided Drill Slot or Special Placement Direction',
    default: 'System Default',
    frontLeft: 'Front and Left',
    frontRight: 'Front and Right',
    backLeft: 'Back and Left',
    backRight: 'Back and Right',
    frontDirection: 'Front Edge Placement Direction',
    enableTip: 'Attention: Only effective for Cloud Layout',
    fixedOn: 'Fixed On:',
    front: 'Front',
    back: 'Back',
    left: 'Left',
    right: 'Right',
    coordinateValue: 'Number of Decimal Places for Coordinate Values:',
    decimalPlaces: 'Decimal Places',
    slotLengthCompensation: 'Slot Length Compensation',
    curveholesLengthCompensation: 'Internal Special Shape Length Compensation',
    slotCompensationEqualZero: 'Slot Edge Compensation When Distance is Zero',
    slotCompensationNotEqualZero: 'Slot Edge Compensation When Distance is Not Zero',
    slotCompensationTip: 'Use this function when processing shows incomplete small rounded corners or insufficient length',
    curveholesCompensationEqualZero: 'Corner length compensation when distance is zero',
    curveholesCompensationTip: 'Enter the value: Radius of the internal special-shaped cutting tool',
    curveholesCompensationTip2: 'When cutting internal alien outside the rectangular edge of the board, all sides containing the alien will be cut simultaneously',
    specialParameter: 'Special Parameter Settings',
    output5FDrillSlotKnifeCode: 'XML2 Milling Slot Tool Code',
    output5FDrillShapeKnifeCode: 'XML2 Milling Shape Tool Code',
    plankTexture: 'XML2 Board Texture',
    offset: 'XML2 Milling Shape Tool Compensation',
    mprConHoleDir: 'Five/Six-Sided Drill MPR File Side Hole Z-Coordinate Reference Plane',
    plankTop: 'Board Upper Surface',
    plankBottom: 'Board Lower Surface',
    codeInfo: 'ban Format File Includes Code Information:',
    bomFile: 'Output bom Format File:',
    plankHeight: 'Board Height Description:',
    plankNum: 'Board Number Description:',
    backZpoint: 'Back Slot Z-Coordinate:',
    plankThick: 'Board Thickness',
    slotDeep: 'Slot Depth',
    outputMprFile: 'File Type',
    oldMPR: 'Old MPR',
    newMPR: 'New MPR',
    mprFileZside: 'Z-axis Reference Plane for Side Holes in Five/Six-Sided Drill MPR File',
    fileTypeOffline: 'The currently selected file type for the five/six-sided drill has been discontinued. Please confirm!',
    permissionErr: 'Identity information has been lost. Please reopen this page from the cabinet!',
    banFileSetting: 'ban Format File Settings',
    banFileCodeInfo: 'ban Format File Contains Code Information:',
    huahuaLine: 'Huahua Automatic Line',
    huahuaLineTip: '(Incompatible with label placement standard)',
    huahuaPartFlag: {
      longSide: 'Long side less than',
      shortSide: 'or short side less than',
      partFlag: 'generate small board identifier for boards',
      tip: '（Label display requires adding "board identifier-small board marker" data, and the Huahua automatic line file will automatically add corresponding data）'
      },
    plankPutWay: 'Plank Placement Method',
    plankPutWayTip: 'If the current production line is enabled Huahua automatic line, the setting of plank placement method is not supported',
    autoHandle: 'Automatic Avoidance of Clamp',
    manualHandle: 'Manual Avoidance Setting',
    fixedFront: 'Fixed Front Edge Banding',
    plankNamePlacement: 'Placement by Plank Name',
    plankNamePlacementTip1: '1. After setting, when the plank name contains the configured field, the corresponding edge of the plank will be fixed to the specified side of the device according to the settings',
    plankNamePlacementTip2: '2. The priority of this setting is higher than the plank placement method setting above',
    plankNamePlacementTip3: '3. This function is only effective for cloud layout; if the current production line has Huahua automatic line enabled, separate plank placement settings are not supported',
    addRow: 'Add Row',
    plankNameTip: 'Please enter the plank name',
    plankSide: 'Plank Edge',
    deviceSide: 'Fixed on Device',
    weldingPlatePlacementEnable: 'Welding Plate Placement Enable',
    onlyBluen: 'Only Effective for Cloud Layout',
    fixedEdge: 'Fixed Long Edge Clamp',
    fixedEdgeRule: 'Rule: Determine the placement of the board',
    fixedEdgeRuleItem1: 'Long edge close to clamp',
    fixedEdgeRuleItem2: 'Edge close to clamp',
    fixedEdgeRuleItem3: 'Hole slot avoid',
    fixedEdgeRuleItem4: 'Priority order',
    satisfiedCondition: 'Condition met',
    handDirection: 'Clamp Position Direction',
    handleMachineTip: 'By rotating, the groove and special shapes automatically avoid the clamp side, making board processing easier',
    handleWidth: 'Clamp Width',
    handleLength: 'Clamp Length',
    handleMaxWidth: 'Maximum Processable Width',
    usefulRange: 'Effective Range',
    plankLongSide: 'Plank Long Side',
    usefulRangeTip: "When plank long-side placement is enabled and the board's long side is within this effective range, the groove and special shape placement will be prioritized",
    moveTip: 'The function of the front and back file identifier has been moved to',
    millingOuter: 'Milling external irregular shapes',
    millingInner: 'Milling internal irregular shapes',
    drilling: 'Machining holes',
    slotting: 'Machining groove',
    knivesTip1: '1. After setting the milling cutter, the cutting path will compensate for its blade radius',
    knivesTip2: '2. Alien cutting carving machines that currently do not support xy axis exchange',
    internalCutting: 'Internal special-shaped cutting under the knife and knife are in the board inside',
    externalCutting: 'External special-shaped cutting under the knife and knife are in the board outside',
    externalCuttingDirection: 'When external special-shaped cutting, the entire edge including the special shape will be cut synchronously',
    allExternalCutting: 'All external shapes',
    onlyArcExternalCutting: 'Only external circular shapes'
    },
  doorWallCabinet: {
    tempErrTip: 'No template for the Door-Wall-Cabinet machine was added, so the processing file cannot be exported. Note: after adding, you need to re-layout.',
    title: 'Door Wall Cabinet',
    guifang: 'Squaring',
    processingTechnology: 'Processing Technology',
    longPlateSecondarySquaring: 'Long Plate Secondary Squaring',
    slotOnDoorPlate: 'Slot on Door Plate',
    setting: 'Door Wall Cabinet Setting'
    },
  PTP: {
    title: 'PTP',
    outputFileFormat: 'Output File Format',
    outputDefaultFileFormat: 'Output Default File Format',
    outputMPRFormat: 'Output MPR File Format',
    fileFormatSettings: 'File Format Settings',
    wrapSettings: 'Line Wrap Format Settings:',
    enCodeSettings: 'File Encoding Format Settings:',
    utf8bom: 'UTF-8 with BOM',
    partCoordinate: 'Part Coordinate',
    xPointSymbol: 'X-Axis Coordinate:',
    yPointSymbol: 'Y-Axis Coordinate:',
    zPointSymbol: 'Z-Axis Coordinate:',
    upRight: 'Positive Value',
    negative: 'Negative Value',
    plankMirroring: 'Board Mirroring',
    plankMirrorSetting: 'Board Mirroring Settings:',
    xAxis: 'X-Axis Mirroring',
    yAxis: 'Y-Axis Mirroring',
    mirrorTip: '(Use this feature when mirroring the board)',
    knifeTable: {
      type: 'Type',
      diameter: 'Diameter Φ',
      offsetX: 'Offset X',
      offsetY: 'Offset Y',
      offsetZ: 'Offset Z',
      offsetNo: 'Offset Number',
      drillVelocity: 'Drilling Velocity [F] mm/min',
      cutVelocity: 'Cutting Velocity [F] mm/min',
      rotationSeep: 'Rotation Speed [S] r/min',
      insertRow: 'Insert Row',
      deleteRow: 'Delete Row'
      },
    labelPool: 'Data Label Pool',
    dragTip: 'Drag or click to copy labels from the label pool to the input box',
    procedure: 'Procedure',
    beginCode: 'Procedure Start Code:',
    endCode: 'Procedure End Code:',
    zzdKnifeBeginCode: 'Spindle Knife Change Start Code:',
    spindleCutter: 'Spindle Cutter',
    zzdKnifeEndCode: 'Spindle Knife Change End Code:',
    verticalDrill: 'Vertical Drill',
    czzBeginCode: 'Vertical Drill Startup Code:',
    czzEndCode: 'Vertical Drill Shutdown Code:',
    czzKnifeBeginCode: 'Vertical Drill Knife Change Start Code:',
    czzKnifeEndCode: 'Vertical Drill Knife Change End Code:',
    sidetrack: 'Side Drill',
    czBeginCode: 'Side Drill Startup Code:',
    czEndCode: 'Side Drill Shutdown Code:',
    czKnifeBeginCode: 'Side Drill Knife Change Start Code:',
    czKnifeEndCode: 'Side Drill Knife Change End Code:',
    pauseCode: 'Pause Code:',
    zSafeHeight: 'Safe distance',
    spindleKnife: 'Main spindle cutter and vertical drill Z-axis safety height',
    sideDrillZ: 'Sidedrill Z-axis safety height',
    sideDrillXY: 'Side drilling X/Y-axis safety distance',
    auxiliaryFunction: 'Auxiliary Function',
    xhDedicatedInfo: 'Generate Dedicated Information for Xinghui Devices',
    xhCheckBox: 'Data:',
    outputSettings: 'Output Settings:',
    partExegesis: 'Generate Part Size Annotations in the File',
    knifeNo: 'Knife Number',
    specailKnifeNo: 'Special Knife Number for Processing Unusual Shapes:',
    slotKnifeNo: 'Slot Cutting Knife Number:',
    fileNamePlaceholder: 'Custom Cutting List',
    slotDrill: 'Straightener Knife'
    },
  glassEquip: {
    title: 'Glass Cutting Machine',
    fileType: 'Processing File Type:',
    sizeReparation: 'Board Size Compensation:',
    cutPreSpace: 'Reserved Spacing for Board Cutting:',
    divideIntoFolders: 'Organize Files into Different Folders Based on Glass Color, Material, and Thickness:'
    },
  translate: {
    search: 'Please enter the Chinese or official translation to find the entry',
    en: 'English',
    es: 'Spanish',
    ar: 'Arabic',
    kz: 'Kazak',
    vi: 'Vietnamese',
    th: 'thai',
    id: 'Indonesian',
    ug: 'Uyghur',
    customTranslate: 'Click to add a custom translation',
    customText: 'Custom translation',
    text: 'Chinese',
    targetLang: 'official translation',
    zh_hant: 'Traditional Chinese'
    },
  preLayoutSetting: {
    title: 'Pre‑Nest Settings',
    titleTip: 'You can preset layout parameters first, layout first, and then select the production line',
    settingTip: 'The parameters set within the production line need to be consistent with the following pre-layout parameters to output the production file, applicable only to cutting machines',
    emptyKnife: 'Tool not filled',
    noModify: 'No changes in settings, no need to save',
    reSet: 'Reset',
    gayPosition: 'Gray squares can switch surplus material placement position',
    surplusPosition: 'Current surplus material placement position',
    click: 'Click',
    grayStart: 'Gray squares can switch the starting point of the workstation',
    currentStart: 'Current workstation starting point',
    holeSlotSetting: 'Punching slot processing settings',
    knifeDiameter: 'Cutting tool diameter',
    currentVersion: 'Current version',
    on: 'On',
    off: 'Off',
    firstShort: 'First Cut - Short Edge Allowance',
    firstLong: 'First Cut - Long Edge Allowance',
    cuttingSplitLong: 'Cutting Long Boards in Two Passes - Long Edge Exceeds',
    cuttingSplitShort: 'Cutting Long Boards in Two Passes - Short Edge Exceeds',
    plankThick: 'Non-door board thickness ≥ ',
    singleDoorThick: 'Door Board Thickness ≥ ',
    normalPlank: 'Regular Board',
    confilictTip: 'There are setting conflicts: {confilictTotal} items',
    selectLine: 'Select production line',
    selectLinePlaceholder: 'Please select a production line',
    lineConfilictTip: 'The selected production line conflicts with {line}',
    preWay: 'Pre-layout Scheme',
    paibanErrTip: 'Changes in the [length and short edge volume] for long board processing may lead to layout failure',
    paibanTip: 'The current layout requires re-layout due to the specified cutting tool for large board material',
    reLayout: 'Re-layout with the current production line',
    fetchErr: 'Failed to fetch pre-layout settings',
    resetSuccess: 'Reset successful',
    resetConfirm: 'Are you sure you want to revert to the historical version?',
    prolineName: 'Production Line Name',
    layoutGap: 'Layout Gap',
    generalThickness: 'Secondary Cutting Object - Regular Board Thickness',
    cutGeneralPlank: 'Secondary Cutting Object - Regular Board',
    cutSingleDoor: 'Secondary Cutting Object - Door Panel',
    secondary_cutting_board_list: 'List of specified board names and cutting board names',
    changeProline: 'Switch Production Line',
    backTip: 'Please return to global layout to select a production line',
    preLayout: 'Nest‑by Pre‑scheme',
    preWayEmpty: '(Empty)Pre-layout Scheme',
    specialConfilictTip: 'The selected production line affects the arc milling bottom process parameters, re-layout is required'
    },
  lunbo: {
    tips: 'Operating Skills',
    introduction: 'Function Introduction',
    qtDownloadText: 'Warm reminder: If the downloaded file is incomplete, please go to the cloud typesetting webpage to download it!'
    },
  sendModal: {
    paibanImgType: 'Types of layout file formats'
    },
  authenticationModal: {
    title: 'Scan QR Code for verification',
    tip: 'Please do not close the dialog before verification is successful!',
    countdownTip: '{countdown} after expiration',
    refreshTip: 'Refresh QR Code',
    qrcodeTip: 'Please scan the QR Code with WeChat to complete the operation',
    qrcodeTip2: 'If the QR Code scanning fails, please allow access to the system in the general settings of the cabinet - user access settings.',
    waiting: 'Waiting for QR Code scanning',
    scanning: 'Scanning QR Code, waiting for verification',
    success: 'Verification successful',
    error: 'Verification failed',
    expired: 'QR Code has expired',
    tip2: 'For the security of your account data, please verify the current operator information',
    tip3: 'The cabinet for trial production must be, {fontStyleStart}asymmetric, to avoid the problem of cabinet mirroring{fontStyleEnd}'
    },
  printTag: {
    dualLanguageTip: 'You do not have permission to generate Chinese-English bilingual labels. Preview only for now—contact sales to enable full access~',
    generateDualLanguageTagTip: 'Generate Chinese-English bilingual labels',
    dualLanguageTip2: 'This feature is paid. Please contact sales to enable it before use~',
    effectiveDataSource: 'Effective Data Source',
    partName: 'Panel Name'
    },
  userAccessToken: {
    createTime: 'Creation time',
    lastUsedTime: 'Last used time',
    expireTime: 'Expiration time',
    status: 'Status',
    tokenNamePlaceholder: 'Please enter token name',
    expireTimeSelectPlaceholder: 'Please select expiration time',
    securityBannerTip: 'Do not share your personal access token with others or expose it in browser or other client code. To protect your account, leaked tokens found in public may be disabled automatically.',
    expired: 'Expired',
    valid: 'Valid',
    remove: 'Remove',
    previewOnceWarning: 'This token is shown only once. Save this secret in a safe, accessible place. Do not share it with others or expose it in browser or other client code.',
    token: 'Token',
    deleteConfirm: 'Are you sure you want to delete this token?',
    userAccessToken: 'User Access Token',
    dayUnit: 'd',
    custom: 'Custom',
    previewModalTitle: 'New personal access token',
    addModalTitle: 'Add new personal access token'
    },
  bujianStore: {
    inputPlaceholder: 'Search replacement by part barcode',
    noData: 'No data',
    loadingErr: 'Supplement plank loading failed',
    bujianStore: 'Replacement Parts',
    awaitStore: 'Nest Pool',
    noDrag: 'Cannot be placed, please click the button to place the board into the supplement library',
    outOfCanvas: 'Cannot be placed, please check the material, color and thickness properties of the board'
    },
  alginTexture: {
    tip: 'This operation will clear the texture alignment info, are you sure?',
    tip2: 'This operation will affect the gap between the parts, causing processing problems, are you sure?',
    group: 'Texture Group',
    groupTemp: 'Texture Group One',
    textureAlignmentPlank: 'Cannot move texture alignment plank'
    },
  customizeFolder: {
    customizeFolder: 'Folder Customization',
    customizeFolderTip: 'Note: After enabling folder customization, the previously set folder division rules will no longer take effect',
    processingFilesTitle: 'Processing file data',
    dragToFolderTip: 'Can be dragged to the left folder as a subfolder or file',
    folderNameEmpty: 'Folder name cannot be empty',
    folderNameExists: 'Folder with the same name exists',
    fileNotFound: 'Failed to get the correct file',
    fileCannotBeClassified: 'This type of file cannot be placed under any classification folder',
    cannotAddAtThisPosition: 'Cannot add at this position',
    fileAlreadyExists: '【{name}】already exists in this folder',
    confirmDeleteFolder: 'Are you sure you want to delete this folder?',
    confirmDeleteItem: 'Are you sure you want to delete 【{name}】?',
    confirmDeleteFolderWithChildren: 'There are other folders/files under this folder, are you sure you want to delete it?',
    deleteFile: 'Delete file',
    addSubFolder: 'Add subfolder',
    editFolder: 'Edit folder',
    deleteFolder: 'Delete folder',
    rootCannotDelete: 'Root directory cannot be deleted',
    newFolder: 'New folder',
    fileUsedCanDrag: 'Used - Can be dragged repeatedly',
    fileDraggable: 'Draggable',
    addFileToFolder: 'Add 【{fileName}】 to {folderName}',
    addFolderTitle: 'Add folder',
    editFolderTitle: 'Edit folder',
    folderNameLabel: 'Folder name',
    folderNamePlaceholder: 'Please enter folder name',
    sequenceStartLabel: 'Incremental sequence start value',
    classifyMethodLabel: 'Classification method',
    nameLengthLimitLabel: 'Character length limit',
    tagInsertTip: 'Click the tag to insert into the folder name',
    classifyTagInsertTip: 'Click the tag to insert into the folder name, files will be classified according to the specified tag',
    engraving_front: 'Engraving machine front file',
    engraving_opposite: 'Engraving machine reverse file',
    engraving_merge: 'Engraving machine merge file',
    engraving_mill: 'Secondary processing horn groove milling',
    engraving_haitang: 'Secondary processing beveled Haitang corner and handle file',
    engraving_arc_slot: 'Secondary processing milling bottom arc slot',
    engraving_line_slot: 'Secondary processing custom tool path',
    engraving_straight_arc_slot: 'Secondary processing arc bending part straight slot',
    engraving_frame_door: 'Secondary processing bone door file',
    engraving_inner_shape: 'Secondary processing inner shape',
    engraving_hole: 'Secondary processing regular hole',
    engraving_slot: 'Secondary processing regular slot',
    engraving_single_file_merge: 'Secondary processing single file merge',
    electronic_saw: 'Electronic saw file',
    glass: 'Glass cutting machine file',
    glass_machine: 'Glass cutting machine',
    side_machine: 'Side hole machine file',
    side_machine_xml3: 'Old version side hole machine XML3 file',
    side_machine_txt: 'Old version side hole machine TXT file',
    side_machine_nc: 'Old version side hole machine NC file',
    dock56F: 'Five/six-sided drilling file',
    ptp: 'PTP file',
    aio: 'All-in-one machine file',
    aio_anc: 'All-in-one machine front ANC file',
    labeling_1: 'Labeling machine file 1',
    labeling_2: 'Labeling machine file 2',
    labeling_3: 'Labeling machine file 3',
    robotic_arm: 'Robotic arm file',
    label_image: 'Label image file',
    label_pdf: 'Label PDF file',
    paiban_image: 'Typesetting image file',
    paiban_pdf: 'Typesetting image PDF file',
    engraving: 'Engraving machine',
    electronic: 'Electronic saw',
    side_hole: 'Side hole machine',
    drilling: 'Five/six-sided drilling',
    labeling: 'Labeling machine',
    robotic: 'Robotic arm',
    label: 'Label',
    warningTip: 'Please note: The curly braces 【{}】 and their contents must be kept intact, do not manually delete/add!',
    fileClassifyError: 'This file cannot be classified according to {classifyNames}',
    folderClassifyByTextureColorThickSize: 'Classify into different folders according to color, material, thickness, and large board size (label files together)',
    unnamed: 'Unnamed',
    specialText: 'Special',
    surplusText: 'Offcuts',
    normalText: 'Normal',
    plankText1: 'Board',
    resetTemplate: 'Reset template',
    resetTemplateConfirm: 'Are you sure you want to reset the template?',
    clearTemplate: 'Clear template',
    clearTemplateConfirm: 'Are you sure you want to clear the template?',
    legendFixedFolder: 'Fixed folder',
    legendClassifyFolder: 'Classified folder',
    legendFixedTag: 'Fixed data',
    legendNormalTag: 'Dynamic data',
    legendClassifyTag: 'Classified dynamic data',
    door_wall_aio: 'Door Wall Cabinet',
    noPermission: 'You do not have permission to use custom folders. Please contact sales to purchase this feature before using it.',
    enableCustomFolder: 'Enable custom folders',
    exporttagTip: 'When exporting tag PDF and image simultaneously, PDF is sent by default'
    },
  paibanTask: {
    pausedTip: 'Paused Task',
    deleteTip: 'Are you sure you want to delete the task "{taskBatch}"? It cannot be recovered after deletion.',
    continueTip: 'Continue Task',
    completed: 'Completed',
    failed: 'Task Failed',
    paused: 'Paused',
    pending: 'Pending',
    running: 'Running',
    extraTip: 'The layout task only shows the data of the past week. Please manually save the task to history after completion!',
    taskStatus: 'Task Status',
    createTaskTip: 'Create layout task, enter backend layout',
    taskBatchTitle: 'Task batch',
    relatedOrderNosTitle: 'Related order numbers',
    progressTitle: 'Layout progress',
    boardCountTitle: 'Board usage estimation',
    optimizedAreaTitle: 'Optimized area estimation',
    productionLineTitle: 'Line',
    operationTitle: 'Actions',
    optimizeRateTitle: 'Optimization rate estimation',
    optimizeRateTip: 'The optimization rate of automatically cut surplus material is not calculated.',
    optimizeRateTip2: 'The specific optimization rate is based on the layout page',
    boardCountTip: 'The specific board usage is based on the layout page',
    optimizedAreaTip: 'The specific optimized area is based on the layout page',
    paibanSettingTip: 'The production line settings for the current task have been modified. The current layout results may conflict with the actual production export files. It is recommended to re-layout the production.',
    dataException: 'Data exception, please refresh the page and try again'
    },
  paibanSetting: {
    advancedSetting: 'Advanced setting',
    advancedFeature: 'Advanced feature',
    surplusCutSpeedUp: 'Surplus cut speed up',
    surplusCutSpeedUpTip4: 'Feature development in progress, please wait',
    surplusCutSpeedUpTip: 'Surplus layout gap is automatically set to 0',
    surplusCutSpeedUpTip2: 'Surplus cutting automatically skips already-cut and edge-trimming paths to improve cutting efficiency',
    surplusCutSpeedUpTip3: 'This feature only works for engraving machines and one-turn engraving machines (do not use with common-edge cutting or common-edge acceleration)',
    surplusCutSpeedUpTip5: 'Only effective for engraving machines and one-turn engraving machines',
    featureDisplay: 'Feature display',
    featureDisplayTip: 'This page only controls whether feature entries are displayed; it does not change whether features are enabled or their parameter settings'
    },
  alignedPlan: {
    deepSearch: 'Deep Search',
    deepSearchTip: 'Exclusive feature: increase calculation depth by re-nesting to get better layout results',
    deepSearchTip2: 'After upgrading Deep Search, re-nest to increase calculation depth for better results. Available for trial now',
    deepSearchTip3: 'Deep Search provides a more board-efficient layout',
    deepSearchTip4: 'You currently do not have Deep Search nesting permission. Please contact sales to purchase.',
    deepSearchTip5: 'After upgrading Deep Search, enjoy dedicated server computing power for better nesting quality. Preview available now'
    }
  }